import React, {Component} from "react";
import {
    Platform,
    StyleSheet,
    TextInput,
    View,
    Animated,
    ScrollView,
    Dimensions,

    StatusBar,
    TouchableOpacategory,
    Image,
    KeyboardAvoidingView,
    Alert,
    TouchableOpacity, Text, I18nManager, BackHandler,
} from "react-native";
import HMActionBar from "../../../../customviews/HMActionBar";

const {width: SCREEN_WIDTH} = Dimensions.get("window");
import {moderateScale} from "../../../../tools/Scaling";
import Colors from "../../../../tools/Colors";
import HMTextView from "../../../../customviews/HMTextView";

let container = null;

const WINDOW_WIDTH = Dimensions.get('window').width;
const BASE_PADDING = 10;

//import Orientation from "react-native-orientation";
import store from "../../../../redux/store";

const theme = {
    title: '#FFF',
    more: '#446984',
    center: '#7B8F99',
    fullscreen: '#446984',
    volume: '#A5957B',
    scrubberThumb: '#234458',
    scrubberBar: '#DBD5C7',
    seconds: '#DBD5C7',
    duration: '#DBD5C7',
    progress: '#446984',
    loading: '#DBD5C7'
}
import {Tools} from "../../../../tools/Tools";
import PathFile from "../../../../assets/PathFile";
import i18n from "../../../../I18n/i18n";
import HMListItemTitle from "../../../../customviews/HMListItemTitle";

import {typeExport} from "../../../../redux/store/type";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import HMVideo from "../../../../customviews/video/HMVideo";
import Popup from "../../../../tools/mapLink/components/Popup";
import HMIcon from "../../../../customviews/HMIcon";
import HMSwiper from "../../../../customviews/swiper/HMSwiper";
import HMModal from "../../../../customviews/modal/HMModal";
import HMMap from "../../../../customviews/map/HMMap";
import HMImageView from "../../../../customviews/HMImageView";
import HMVoicePlayer from "../../../../customviews/voice/HMVoicePlayer";
import * as NavigationService from "../../../../redux/NavigationService";
import HMFlatList from "../../../../customviews/HMFlatList";
import HMBottomBarItem137 from "../../../../customviews/bottombarItem/HMBottomBarItem137";

import HMListCheckBox from "../../../../customviews/HMListCheckBox";
import HMTextInput from "../../../../customviews/HMTextInput";


var sound = null;
var dateFinal = null;
var content = null;
const initialLayout = {width: Dimensions.get('window').width};
export default class DetailsOperatorApplyScreen extends Component {
    _onViewableItemsChanged = ({viewableItems, changed}) => {
    };

    _viewabilityConfig = {
        itemVisiblePercentThreshold: 50
    };

    constructor(props) {
        super(props);
        container = this;

        let {resultAll, item} = props.route.params;
        let {
            files, video, audio, image,
            IsCurrentPlan,
            CurrentPlanCost,
            CurrentPlanDate,
            IsNextPlan,
            NextPlanCost,
            NextPlanDate,
            DescriptionPlan,
        } = item;

        let checkAudio = audio || audio === null ? audio : (files && files.length > 0 && (files.find(k => k.type === 'audio/aac')) && (files.find(k => k.type === 'audio/aac')).file)
        let checkImage = image || image === null ? image : (files && files.length > 0 && (files.find(k => k.type === 'image/jpeg')) && (files.find(k => k.type === 'image/jpeg')).file)
        let checkVideo = video || video === null ? video : (files && files.length > 0 && (files.find(k => k.type === 'video/mp4')) && (files.find(k => k.type === 'video/mp4')).file)
        let sliderWidth = 1;
        let itemWidth = 1;
        let slideHeight = 1;
        let widthOriginal = Platform.OS === "web" ? 1 : typeExport._WIDTH;

        if (Platform.OS === "web") {
            let viewportWidth = document.body.clientWidth;
            let viewportHeight = document.body.clientHeight;
            widthOriginal = document.body.clientWidth;

            slideHeight = viewportHeight * 0.35;


            sliderWidth = viewportWidth;
        }
        // if (!this.state.arrayDate || this.state.arrayDate.length === 0) {
        //     //   dateFinal = itemLastWork.date_split;
        //     this.state.arrayDate.push(itemLastWork)
        // }
        // else if (!resultDataSplit) {
        //     //  dateFinal = itemLastWork.date_split;
        //     this.state.arrayDate.push(itemLastWork)
        // }

        // let arrr = [];
        // let lllll = props.route.params.item.lastWork;
        // for (let i = 0; i < lllll.length; i++) {
        //     let resultDataSplit = this.state.arrayDate.find(obj => obj.date_split = lllll[i].date_split);
        //     if (resultDataSplit) {
        //
        //     }
        //     else {
        //
        //     }
        //
        // }
        let res_item = props.route.params.item;
        /*    res_item["listMessageExpert"] = [{
                id: 1,
                name: "علی ظفریان",
                date: "1401/4/1 9:23",
                description: "باسلام بودجه مورد نیاز برآورده گردد",
                files: [{
                    file: "https://my.arak.ir/proxy/arak/137/proxyPortal.php/storage/2020/December/week3/484887_1608533505888.aac",
                    type: "audio/aac"
                }, {
                    file: "https://my.arak.ir/proxy/arak/137/proxyPortal.php/storage/2021/May/week2/564508_1620808463020.mp4",
                    type: "video/mp4"
                }, {
                    file: "https://my.arak.ir/proxy/arak/137/proxyPortal.php/storage/2021/May/week2/564514_1620808463020.jpg",
                    type: "image/jpeg"
                }],
            }];*/
        // res_item["imageExpert"] = "http://portal.arak.ir/layouts/v7/lib/todc/img/worker.png?v=1";
        // res_item["_dateUpdate_O"] = Date.now();
        res_item.lastWork = this.addFlagDate(res_item.lastWork)
        this.state = {
            focusedAnim: new Animated.Value(1),

            widthOriginal: widthOriginal,
            indexSelectVoice: -1,
            itemWidth: itemWidth,
            sliderWidth: sliderWidth,
            slideHeight: slideHeight,
            slider1ActiveSlide: 0,
            modalHeight: 0,
            isFull: false,

            FinalList: [],


            listVideo: [],
            listImage: [],
            listVoice: [],
            listOthers: [],

            // listOthersTasks: [],


            ShowImage: false,
            ShowVideo: false,
            visibleModal: '',
            playSeconds: 0.0,
            playState: 'playing',

            index: 0,
            setIndex: 0,
            routes: [
                {key: 'first', title: 'وظیفه'},
                {key: 'second', title: i18n.t('constant.Information')},
                {key: 'third', title: i18n.t('constant.MessageCirculation')},
            ],

            pathAudio: checkAudio,
            pathVideo: checkVideo,
            more: false,
            largeMap: false,
            arrayDate: [],
            stateItemExtra: res_item,
            alaki: false,

            listExpert: [1, 2],

            // indexSelectCheckBoxProgramNow: 2,
            // indexSelectCheckBoxProgramFuture: 2,

            // IsCurrentPlan,
            // CurrentPlanCost,
            // CurrentPlanDate,
            // IsNextPlan,
            // NextPlanCost,
            // NextPlanDate,
            indexSelectCheckBoxProgramNow: IsCurrentPlan ? IsCurrentPlan : 2,
            TextInputProgramNow: CurrentPlanDate ? CurrentPlanDate : null,
            TextInputCostProgramNow: CurrentPlanCost ? CurrentPlanCost : null,
            indexSelectCheckBoxProgramFuture: IsNextPlan ? IsNextPlan : 2,
            TextInputProgramFuture: NextPlanDate ? NextPlanDate : null,
            TextInputCostProgramFuture: NextPlanCost ? NextPlanCost : null,
            TextInputDescriptionExpert: DescriptionPlan ? DescriptionPlan : null,

            ListStateChange: resultAll?.stateChange
        };


        if (files)
            for (let i = 0; i < files.length; i++) {
                let f = String(files[i].type);

                if (f.search('audio/') >= 0)
                    this.state.listVoice.push(files[i])

                else if (f.search('image/') >= 0)
                    this.state.listImage.push(files[i])

                else if (f.search('video/') >= 0)
                    this.state.listVideo.push(files[i])
                else {

                    this.state.listOthers.push(files[i])

                }

            }


        this.onFullScreen = this.onFullScreen.bind(this);// you should bind this to the method that call the props
        this.props.navigation.addListener('focus', () => {


                this.setState({
                    alaki: !this.state.alaki,
                })
                container = this;
            }
        )
    }

    addFlagDate(data) {
        if (data && data.length > 0) {
            //  alert("fhfh")
            let result_lastWork = data;
            let arraySearch = [];
            let start = null;
            let end = null;
            let count = 0;
            for (let i = 0; i < result_lastWork.length; i++) {
                let resultDataSplit = arraySearch.find(obj => {
                    //  return obj.date_split === result_lastWork[i].date_split
                    return obj.date_split === result_lastWork[i].date_split
                });

                //
                if (start && count > 0 && !resultDataSplit) {
                    count = 0;
                    end = true;
                    start = null;
                    result_lastWork[i].flagDate = true;
                }
                if (resultDataSplit) {
                    count = +1;

                }
                else {
                    end = null;
                    arraySearch.push(result_lastWork[i])
                    start = result_lastWork[i].date_split;
                    count = 1;
                }

                if (i === result_lastWork.length - 1 && !end) {
                    result_lastWork[i].flagDate = true;
                }
                //if (key === action.index) {
                // if (!resultDataSplit) {
                //     // let ll = val.lastWork.concat(action.data);
                //     arraySearch.push(result_lastWork[i])
                //     result_lastWork[i].flagDate = true;
                //     //   val.lastWork.push(action.data)
                //
                // }
            }


            return result_lastWork;
        }

        return data;

    }

    getData(type) {
        let paramss = {

            "_operation": typeExport._Shahrdar,
            'mode': type ? "" : typeExport._GetCsStatus,
            "_session": store.getState().reducerSplashGetAllData.token,
            "customValue": this.state.stateItemExtra.status,
            "state_params": this.props.route.params,
            "lang": i18n.locale,

        };
        // this.props.callService(urlGetAllData, `?lang=${i18n.locale}&token=${token}&token_fb=${token_fb}`, TypeGetAllData, 'POST', token, token_fb, imageBack)
        this.props.callService(typeExport._baseUrlSainaShahrdar, paramss, type ? type : typeExport.TypeGetDetailsOperatorApplyScreen, typeExport._GET, store.getState().reducerSplashGetAllData.token)
    }

    setDataServer(data) {
        let {
            indexSelectCheckBoxProgramNow,
            TextInputProgramNow,
            TextInputCostProgramNow,
            indexSelectCheckBoxProgramFuture,
            TextInputProgramFuture,
            TextInputCostProgramFuture,
            TextInputDescriptionExpert,
        } = this.state;
        let paramss = {

            "_operation": typeExport._Shahrdar,
            'mode': "ChangeState",
            "_session": store.getState().reducerSplashGetAllData.token,
            "customValue": this.state.stateItemExtra.status,
            "record": this.state.stateItemExtra.id,
            "state_params": this.props.route.params,
            "lang": i18n.locale,

            "IsCurrentPlan": indexSelectCheckBoxProgramNow,
            "CurrentPlanCost": TextInputCostProgramNow,
            "CurrentPlanDate": TextInputProgramNow,

            "IsNextPlan": indexSelectCheckBoxProgramFuture,
            "NextPlanCost": TextInputProgramFuture,
            "NextPlanDate": TextInputCostProgramFuture,

            "description": TextInputDescriptionExpert,

            //"ganttime": i18n.locale,
            "type": data.name,
            "status": data.id,

        };
        // this.props.callService(urlGetAllData, `?lang=${i18n.locale}&token=${token}&token_fb=${token_fb}`, TypeGetAllData, 'POST', token, token_fb, imageBack)
        this.props.callService(typeExport._baseUrlSainaShahrdar, paramss, typeExport.TypeSetDetailsOperatorApplyScreen, typeExport._GET, store.getState().reducerSplashGetAllData.token)
    }

////////////////audio///////////////

    async _pause() {
        sound.pause();

    }

    async _stop() {
        sound.stop();

    }

    async _play(audioPath) {


        sound = await
            new Sound(audioPath, '', (error) => {
                if (error) {

                    console.log('failed to load the sound', error);
                    return;
                }
                sound.play((success) => {
                    if (success) {

                        this.setState(
                            {
                                playState: 'playing'
                            },
                            () => {
                                // this._pause()

                            }
                        )
                    } else {
                        console.log('playback failed due to audio decoding errors');
                    }
                });
                if (this.timeout) {
                    clearInterval(this.timeout);
                }
                this.timeout = setInterval(() => {
                    if (sound && sound.isLoaded() && (this.state.playState == 'playing' || this.state.playState == 'paused')) {
                        sound.getCurrentTime((seconds, isPlaying) => {
                            this.setState({playSeconds: seconds});
                        })
                    }
                }, 100);
            });


    }

    switchIcon() {
//playing, paused ,record , stop
        switch (this.state.playState) {
            case 'playing':


                return PathFile.image.img_play

            case 'paused':

                return PathFile.image.img_pause

            default :

        }
    }

    switchOnPress(audioPath) {
        switch (this.state.playState) {


            case 'playing':

                this.setState(
                    {
                        playState: 'paused'
                    },
                    () => {
                        this._play(audioPath)
                    }
                )
                break;

            case 'paused':
                this.setState(
                    {
                        playState: 'playing'
                    },
                    () => {
                        this._pause()

                    }
                )
                break;


            default :

        }


    }

    /////////////////////////
    hiddenModal() {
        //this._stop()
        if (sound) {
            this.setState({
                    playState: 'playing'
                },
                () => {

                })

            this._pause()

        }
        this.setState({
                visibleModal: '',
                sliderList: [],
            },
            () => {
                // Orientation.unlockAllOrientations();
                // Orientation.lockToPortrait();
            })
    }

    onShow(data) {
        this.setState({
            visibleModal: data,
            Modalcategory: true

        });
    }

    pauseVideo(index) {
        this.video.pause()
        if (this[`video${index}`]) {
            this[`video${index}`].pause()

            // let p = "paused" + index
            // this.setState({[p]: true})
            //  this.video.pauseAsync();
        }
    }

    playVideo = () => {
        if (this.video) {
            // this.video.playAsync();
            this.setState({paused: false})

        }
    }

    handlePlaying = (isVisible) => {

        isVisible ? this.playVideo() : this.pauseVideo();
    }
    onFullScreen = (value) => {
        // Set the params to pass in fullscreen status to navigationOptions
        this.props.navigation.setParams({
            fullscreen: !value
        })
        if (value) {
            // Orientation.lockToLandscape();
        } else {
            //  Orientation.unlockAllOrientations();
            //  Orientation.lockToPortrait();
        }
        this.setState({
            isFull: value
        })
    }

    async onFlyToPress(long, lat) {
        //await this.map.moveTo([ 49.66736778005486,34.08777640387088], 1000);
        /*      this.map.setCamera({
                  //  centerCoordinate: [49.66736778005486, 34.08777640387088],
                  centerCoordinate: [long, lat],
                  zoom: 16,
                  duration: 2000,
              })*/
        if (Platform.OS === "web") {
            //this.map.leafletElement.flyTo(c, 20, this.getZoomPanOptions())
            this.map.mapRef.current.flyTo([lat, long], 18)

        }
        else {
            const camera = await this.map.getCamera();

            camera.zoom = 17;
            camera.center.latitude = lat;
            camera.center.longitude = long;
            this.map.animateCamera(camera, {duration: 2000});
        }
        // this.onFlyToComplete();
    }

    centerMap(long, lat) {

        this.map.setCamera({
            //centerCoordinate: [typeExport.Longitude, typeExport.Latitude],
            centerCoordinate: [long, lat],
            zoom: 16,
            // duration: 2000,
            // mode: MapboxGL.CameraModes.Flight,
        });

    }

    componentWillReceiveProps(props) {
    }

    showDialogUpdateApp() {
        this.setState({showDialogUpdateAppCustomize: true})
    }

    componentDidUpdate(prevProps) {
    }

    async componentDidMount() {
        let {item, type, indexExtra, pageDetails, item_parent} = this.props.route.params;
        /*      if (item_parent.type == 7) {
                  const config = {
                      headers: {
                          "Content-Type": "multipart/form-data; charset=utf-8;",
                          // 'Content-Type': 'application/json',
                          //  "Authorization": `Basic ${params.token}`,
                          timeout: typeExport._TIMEOUT,
                      }
                  };
                  const formData = new FormData();
                  formData.append('mode', "GetExperts");
                  formData.append('token', "GetExperts");

                  axios.post(url, formData, config)
                      .then(async response => {

                          func ? func(response) : null;
                      }).catch((e) => {
                      func ? func(null) : null;

                      console.log(e)
                  })
              }*/


    }

    componentWillMount() {
        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                const slideHeight = viewportHeight * 0.35;


                const sliderWidth = viewportWidth;

                container.setState({
                        widthOriginal: document.body.clientWidth,
                        widthV: document.body.clientWidth > 600 ? document.body.clientWidth / 2.05 : document.body.clientWidth,

                        //    widthV: document.body.clientWidth,
                        heightV: document.body.clientHeight,
                        // itemWidth: itemWidth,
                        sliderWidth: sliderWidth,
                        slideHeight: slideHeight,
                    },
                )


            })
        let {title, description, latitude, longitude, address, code, status, files, createdtime, comment} = this.state.stateItemExtra;
        //   let checkVideo = files && files.length > 0 ? files.find(k => k.type === 'video/mp4') : false;
        //  let checkImage = files && files.length > 0 ? files.find(k => k.type === 'image/jpeg') : false;
        BackHandler.addEventListener('hardwareBackPress', this.handleBackButton);
    }

    componentWillUnmount() {


        if (Platform.OS === "web") {
        }
        else {

            BackHandler.removeEventListener('hardwareBackPress', this.handleBackButton);

            if (sound) {
                sound.release();
                sound = null;
            }
            if (this.timeout) {
                clearInterval(this.timeout);
            }
        }


    }


    handleBackButton = () => {

        if (this.state.visibleModal === 'selectVideo' || this.state.visibleModal === 'selectSlider') {
            this.setState({
                visibleModal: ''
            })
        } else {
            this.props.navigation.pop()
        }

        return true;
    };

    render() {

        let {setIndex, routes, index, slider1ActiveSlide, focusedAnim, listExpert} = this.state
        const url = 'https://your-url.com/video.mp4'
        const logo = 'https://your-url.com/logo.png'
        // const placeholder = 'https://your-url.com/placeholder.png'
        const titleVideo = 'My video title'

        let {title, description, latitude, longitude, address, code, status, files, createdtime, comment, video, audio, image, subject, date, category, lastWork, messageid, registrar} = this.state.stateItemExtra;
        let {item, type, indexExtra, pageDetails, item_parent} = this.props.route.params;
        pageDetails = (item_parent?.type == 7 || type == "requestMahalehMa") ? true : (pageDetails ? pageDetails : !(lastWork && lastWork.length > 0));

        // let checkVideo = video ? video : (files && files.length > 0 && files.find(k => k.type === 'video/mp4') ? files.find(k => k.type === 'video/mp4').video : null);
        // let checkImage = image ? image : (files && files.length > 0 && files.find(k => k.type === 'image/jpeg') ? files.find(k => k.type === 'image/jpeg').image : null);

        // let checkAudio = audio || audio === null ? audio : (files && files.length > 0 && (files.find(k => k.type === 'audio/aac')) && (files.find(k => k.type === 'audio/aac')).file)
        // let checkImage = image || image === null ? image : (files && files.length > 0 && (files.find(k => k.type === 'image/jpeg')) && (files.find(k => k.type === 'image/jpeg')).file)
        // let checkVideo = video || video === null ? video : (files && files.length > 0 && (files.find(k => k.type === 'video/mp4')) && (files.find(k => k.type === 'video/mp4')).file)

        // let checkAudio = audio || audio === null ? audio : (files && files.length > 0 && (files.find(k => k.type === 'audio/aac')) && (files.find(k => k.type === 'audio/aac')))
        // let checkImage = image || image === null ? image : (files && files.length > 0 && (files.find(k => k.type === 'image/jpeg')) && (files.find(k => k.type === 'image/jpeg')))
        // let checkVideo = video || video === null ? video : (files && files.length > 0 && (files.find(k => k.type === 'video/mp4')) && (files.find(k => k.type === 'video/mp4')))

        return (
            <View style={{flex: 1,}}>
                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>

                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>


                        <View
                            style={{flex: 1,}}>
                            <HMActionBar
                                //menu
                                props={this.props} statusBarTransparent
                                //   text={i18n.t('Privatizations.title')}
                                text={pageDetails ? "جزئیات بیشتر" : i18n.t('constant.Details')}

                                ViewCenter={() => {
                                    return <View
                                        style={{
                                            width: moderateScale(38),
                                            flexDirection: "row",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}>
                                        <Image source={item.imageUser ? item.imageUser : PathFile.image.user}
                                               style={[{
                                                   alignSelf: 'center',
                                                   width: moderateScale(38),
                                                   height: moderateScale(38),
                                                   // marginTop: moderateScale(10),

                                               }, item.imageUser ? {tintColor: Colors.white,} : {}]}/>

                                        <HMTextView

                                            type={"bold"}
                                            noFont={!I18nManager.isRTL}
                                            style={{
                                                fontSize: moderateScale(12),
                                                color: Colors.white,

                                                marginStart: moderateScale(6)
                                            }}
                                            //text={'اراک خ هپکو خ امام حسین'}
                                            text={item.contact}
                                            //   text={"98/03/21"}
                                        />

                                    </View>
                                }}
                                headerVisibility
                                more_menu
                                back
                                onBackPress={() => this.props.navigation.pop()}

                            />


                            <View style={{flex: 1,}}>
                                {/*<MaterialTabs*/}
                                {/*items={['وظیفه', i18n.t('constant.Information'), i18n.t('constant.MessageCirculation')]}*/}
                                {/*selectedIndex={this.state.index}*/}
                                {/*onChange={(i) => {*/}
                                {/*this.setState({index: i})*/}
                                {/*}}*/}
                                {/*barColor="#1fbcd2"*/}
                                {/*indicatorColor="#fffe94"*/}
                                {/*activeTextColor="white"*/}
                                {/*/>*/}


                                {
                                    pageDetails ?
                                        <ScrollView
                                            ref={ref => {
                                                this.scrollView = ref
                                            }}
                                        >
                                            {this.renderDetails()}
                                        </ScrollView> :
                                        <View style={{width: "100%"}}>
                                            {this.renderDetails()}
                                        </View>
                                }
                                {
                                    pageDetails ?
                                        null :
                                        <View
                                            style={{
                                                width: "100%",
                                            }}>
                                            <View style={{

                                                flexDirection: 'row',
                                                ///  backgroundColor:'#a8ee7c',
                                                marginHorizontal: moderateScale(5),
                                                marginTop: moderateScale(8),
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                alignSelf: 'center',
                                            }}>
                                                <HMTextView


                                                    type={"bold"}
                                                    noFont={!I18nManager.isRTL}
                                                    style={{
                                                        fontSize: moderateScale(12),
                                                        color: Colors.blackLight,
                                                        textAlign: 'center',
                                                        // marginTop: moderateScale(10)
                                                    }}
                                                    text={i18n.t('constant.MessageCirculation')}
                                                    //   text={"98/03/21"}
                                                />


                                            </View>


                                        </View>
                                }

                                {
                                    pageDetails ?
                                        null :

                                        <HMFlatList

                                            // ItemSeparatorComponent={
                                            //     <View style={{
                                            //         width: '100%',
                                            //         height: moderateScale(1),
                                            //         backgroundColor: '#4f4f4f'
                                            //     }}/>
                                            // }
                                            // data={lastWork === null || !lastWork ? [] : lastWork}
                                            // extraData={lastWork}
                                            ref={(ref) => {
                                                //this.list = ref.flatListRef.current;
                                                this.list = ref && ref.flatListRef?.current;
                                            }}
                                            extraData={this.state}
                                            keyExtractor={(item, index) => index.toString() + (lastWork?.length)}

                                            data={lastWork === null || !lastWork ? [] : lastWork}
                                            // style={{transform: [{scaleY: -1}]}}
                                            // initialScrollIndex={1}
                                            renderItem={({item: itemLastWork, index: indexLastWork}) => {
                                                let {files} = itemLastWork;
                                                let checkType = (itemLastWork.type != "mine");
                                                // let resultDataSplit = this.state.arrayDate.find(obj => obj.date_split = itemLastWork.date_split);
                                                // let checkAudio = audio || audio === null ? audio : (files && files.length > 0 && (files.find(k => k.type === 'audio/aac')) && (files.find(k => k.type === 'audio/aac')).file)
                                                // let checkImage = image || image === null ? image : (files && files.length > 0 && (files.find(k => k.type === 'image/jpeg')) && (files.find(k => k.type === 'image/jpeg')).file)
                                                // let checkVideo = video || video === null ? video : (files && files.length > 0 && (files.find(k => k.type === 'video/mp4')) && (files.find(k => k.type === 'video/mp4')).file)
                                                //
                                                // let listVoice = [];
                                                // let listImage = [];
                                                // let listVideo = [];
                                                // let listOthers = [];
                                                // if (files)
                                                //     for (let i = 0; i < files.length; i++) {
                                                //         let f = String(files[i].type);
                                                //
                                                //         if (f.search('audio/') >= 0)
                                                //             listVoice.push(files[i])
                                                //
                                                //         else if (f.search('image/') >= 0)
                                                //             listImage.push(files[i])
                                                //
                                                //         else if (f.search('video/') >= 0)
                                                //             listVideo.push(files[i])
                                                //         else {
                                                //             listOthers.push(files[i])
                                                //         }
                                                //
                                                //     }

                                                // if (!this.state.arrayDate || this.state.arrayDate.length === 0) {
                                                //     //   dateFinal = itemLastWork.date_split;
                                                //     this.state.arrayDate.push(itemLastWork)
                                                // }
                                                // else if (!resultDataSplit) {
                                                //     //  dateFinal = itemLastWork.date_split;
                                                //     this.state.arrayDate.push(itemLastWork)
                                                // }

                                                return (
                                                    <View key={indexLastWork}
                                                          style={{
                                                              width: "100%",
                                                              //transform: [{scaleY: -1}]
                                                          }}
                                                    >

                                                        {
                                                            !itemLastWork.flagDate ?
                                                                null
                                                                :
                                                                <View
                                                                    style={{

                                                                        alignSelf: 'center',
                                                                        width: moderateScale(130),
                                                                        height: moderateScale(36),
                                                                        backgroundColor: Colors.blackLight,
                                                                        borderRadius: moderateScale(12),
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        marginTop: moderateScale(8)
                                                                    }}>

                                                                    <HMTextView

                                                                        type={"bold"}
                                                                        noFont={!I18nManager.isRTL}
                                                                        style={{
                                                                            fontSize: moderateScale(14),
                                                                            color: Colors.white,

                                                                            // marginTop: moderateScale(10)
                                                                        }}
                                                                        //text={'اراک خ هپکو خ امام حسین'}
                                                                        text={itemLastWork.date_split}
                                                                        //   text={"98/03/21"}
                                                                    />
                                                                </View>

                                                        }

                                                        <View
                                                            style={{
                                                                width: "90%",
                                                                backgroundColor: checkType ? Colors.white : "#effdde",
                                                                borderRadius: moderateScale(10),
                                                                marginVertical: moderateScale(4),
                                                                alignSelf: checkType ? "flex-end" : "flex-start",
                                                                alignItems: checkType ? "flex-end" : "flex-start"

                                                            }}>
                                                            {/*         <HMTextView

                                                                    type={"bold"}
                                                                    noFont={!I18nManager.isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(18),
                                                                        color: Colors.blackLight,

                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    //text={'اراک خ هپکو خ امام حسین'}
                                                                    text={indexLastWork + ""}
                                                                    //   text={"98/03/21"}
                                                                />*/}
                                                            {
                                                                checkType ?
                                                                    <View
                                                                        style={{
                                                                            width: '100%',
                                                                            flexDirection: "row",
                                                                            justifyContent: "flex-end",
                                                                            alignItems: "center",
                                                                            padding: moderateScale(4)
                                                                        }}>

                                                                        <HMTextView

                                                                            //  type={"bold"}
                                                                            noFont={!I18nManager.isRTL}
                                                                            style={{
                                                                                fontSize: moderateScale(12),
                                                                                color: itemLastWork.color ? itemLastWork.color : Colors.colorDarkText,
                                                                                margin: moderateScale(6)

                                                                                // marginTop: moderateScale(10)
                                                                            }}
                                                                            text={itemLastWork.user ? itemLastWork.user : ""}
                                                                        />
                                                                        <HMTextView

                                                                            type={"bold"}
                                                                            noFont={!I18nManager.isRTL}
                                                                            style={{
                                                                                fontSize: moderateScale(13),
                                                                                color: itemLastWork.color ? Colors.white : Colors.colorDarkText,
                                                                                margin: moderateScale(6)

                                                                                // marginTop: moderateScale(10)
                                                                            }}
                                                                            text={itemLastWork.role ? itemLastWork.role : ""}
                                                                            styleRoot={[itemLastWork.color && itemLastWork.role ? {
                                                                                borderRadius: moderateScale(16),
                                                                                backgroundColor: itemLastWork.color,
                                                                                marginHorizontal: moderateScale(4),
                                                                            } : {}]}
                                                                        />
                                                                        <View style={{
                                                                            width: moderateScale(48),
                                                                            height: moderateScale(48),
                                                                            borderRadius: moderateScale(24),
                                                                            borderColor: Colors.gray,
                                                                            borderWidth: moderateScale(1),
                                                                            overflow: "hidden"
                                                                        }}>
                                                                            <HMImageView
                                                                                _backgroundColorLoading={Colors.transparent}
                                                                                //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                                                                uriComplete={itemLastWork.image}
                                                                                styleText={{marginTop: moderateScale(10)}}
                                                                                borderRadius={4}
                                                                            />
                                                                        </View>


                                                                    </View>
                                                                    :
                                                                    null
                                                            }


                                                            <HMTextView

                                                                type={"bold"}
                                                                noFont={!I18nManager.isRTL}
                                                                style={{
                                                                    fontSize: moderateScale(14),
                                                                    color: Colors.colorDarkText,
                                                                    margin: moderateScale(6)

                                                                    // marginTop: moderateScale(10)
                                                                }}
                                                                text={itemLastWork.comment ? itemLastWork.comment : ""}
                                                            />


                                                            {this.renderFiles(files, indexLastWork)}


                                                            <HMTextView

                                                                // type={"bold"}
                                                                noFont={!I18nManager.isRTL}
                                                                style={{
                                                                    fontSize: moderateScale(12),
                                                                    color: Colors.colorDarkText,
                                                                    margin: moderateScale(6)

                                                                    // marginTop: moderateScale(10)
                                                                }}
                                                                text={itemLastWork.time ? itemLastWork.time : ""}
                                                                styleRoot={{
                                                                    width: "100%",
                                                                    flexDirection: "row",
                                                                    justifyContent: !checkType ? "flex-start" : "flex-end"
                                                                }}
                                                            />
                                                        </View>
                                                    </View>
                                                );
                                                /*      return (
                                                          <View
                                                              style={{
                                                                  flex: 1,
                                                                  marginVertical: moderateScale(4),
                                                                  backgroundColor: Colors.white,
                                                                  marginHorizontal: moderateScale(10),
                                                                  //  marginVertical: moderateScale(2),
                                                                  // padding: moderateScale(6)
                                                              }}>
                                                              {/!*     <Card>
                                                                      <CardItem cardBody style={{
                                                                          paddingLeft: 0,
                                                                          paddingRight: 0,
                                                                          paddingTop: 0,
                                                                          paddingBottom: 0,
                                                                      }}>*!/}
                                                              <View
                                                                  style={{
                                                                      //paddingVertical: moderateScale(10),
                                                                      width: '100%',

                                                                      padding: moderateScale(6)
                                                                  }}
                                                              >


                                                                  <View style={{
                                                                      flexDirection: 'row',
                                                                      alignSelf: "center",
                                                                      width: '100%'
                                                                  }}>
                                                                      <View style={{flex: .6}}>
                                                                          <HMTextView

                                                                              type={"bold"}
                                                                              //   noFont={!I18nManager.isRTL}
                                                                              style={{
                                                                                  fontSize: moderateScale(12),
                                                                                  color: Colors.colorDark,

                                                                                  // marginTop: moderateScale(10)
                                                                              }}
                                                                              text={item.user + (item.role ? ` ( ${item.role} ) ` : "")}
                                                                              //   text={"98/03/21"}
                                                                          />

                                                                      </View>

                                                                      <View
                                                                          style={{
                                                                              flex: .4,
                                                                              flexDirection: 'row',
                                                                              justifyContent: 'flex-end'
                                                                          }}>
                                                                          <HMTextView

                                                                              //type={"bold"}
                                                                              noFont={!I18nManager.isRTL}
                                                                              style={{
                                                                                  fontSize: moderateScale(11),
                                                                                  color: Colors.colorDarkText,


                                                                                  // marginTop: moderateScale(10)
                                                                              }}
                                                                              text={item.date}
                                                                          />
                                                                      </View>


                                                                  </View>

                                                                  <View
                                                                      style={{
                                                                          flexDirection: 'row',
                                                                          flex: 1,
                                                                          marginVertical: moderateScale(6),
                                                                          marginHorizontal: moderateScale(3)
                                                                      }}>
                                                                      <HMTextView

                                                                          type={"bold"}
                                                                          noFont={!I18nManager.isRTL}
                                                                          style={{
                                                                              fontSize: moderateScale(12),
                                                                              color: item.color ? item.color : Colors.colorDarkText,

                                                                              // marginTop: moderateScale(10)
                                                                          }}
                                                                          text={item.status}
                                                                      />


                                                                  </View>
                                                                  <View
                                                                      style={{
                                                                          flexDirection: 'row',
                                                                          width: "100%",

                                                                          marginBottom: moderateScale(6),
                                                                          marginHorizontal: moderateScale(3)
                                                                      }}>

                                                                      <HMTextView

                                                                          // type={"bold"}
                                                                          //   noFont={!I18nManager.isRTL}
                                                                          style={{
                                                                              fontSize: moderateScale(12),
                                                                              color: Colors.colorDark,

                                                                              // marginTop: moderateScale(10)
                                                                          }}
                                                                          text={item.comment ? item.comment : ""}
                                                                          //   text={"98/03/21"}
                                                                          styleRoot={{
                                                                              //  flexDirection: "row",
                                                                              flex: 1,
                                                                              //  width:'100%',
                                                                              //   justifyContent: "flex-end",
                                                                              flexWrap: 'wrap',

                                                                          }}
                                                                      />
                                                                  </View>
                                                                  {/!*   <View style={{
                                                                  width: '100%',
                                                                  height: moderateScale(1),
                                                                  backgroundColor: '#4f4f4f'
                                                              }}/>*!/}
                                                                  <View style={{width: "100%", flexDirection: 'row',}}>
                                                                      <View style={{
                                                                          flex: .5,
                                                                          flexDirection: 'row',
                                                                      }}>


                                                                          {/!*{*!/}

                                                                          {/!*<Lightbox*!/}
                                                                          {/!*renderContent={() => (*!/}
                                                                          {/!*<View style={{*!/}
                                                                          {/!*width: typeExport.WIDTH,*!/}
                                                                          {/!*height: typeExport.HEIGHT*!/}
                                                                          {/!*}}>*!/}
                                                                          {/!*{*!/}
                                                                          {/!*<Image*!/}
                                                                          {/!*style={{*!/}
                                                                          {/!*flex: 1,*!/}
                                                                          {/!*resizeMode: 'contain'*!/}
                                                                          {/!*}}*!/}
                                                                          {/!*source={{uri: checkImage}}*!/}
                                                                          {/!*!/>*!/}

                                                                          {/!*}*!/}

                                                                          {/!*</View>*!/}
                                                                          {/!*)}>*!/}
                                                                          {/!*<HMIcon name={"md-image"} style={{*!/}
                                                                          {/!*alignSelf: 'center',*!/}
                                                                          {/!*!// width: moderateScale(14),*!/}
                                                                          {/!*color: checkImage ? Colors.colorPrimaryDark : Colors.gray,*!/}
                                                                          {/!*fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),*!/}
                                                                          {/!*textAlign: 'center'*!/}
                                                                          {/!*}}/>*!/}

                                                                          {/!*</Lightbox>*!/}


                                                                          {/!*}*!/}
                                                                          {


                                                                              <TouchableOpacity
                                                                                  onPress={
                                                                                      () => listVideo.length > 0 ? this.setState({
                                                                                              visibleModal: "selectVideo",
                                                                                              // pathVideo: checkVideo,
                                                                                              sliderList: listVideo,

                                                                                              slider1ActiveSlide: 0
                                                                                          })

                                                                                          :
                                                                                          null
                                                                                  }

                                                                                  style={{
                                                                                      // flex: .33,
                                                                                      flexDirection: 'row',
                                                                                      alignItems: 'center',
                                                                                      justifyContent: 'center',
                                                                                      marginHorizontal: moderateScale(3)
                                                                                  }}>
                                                                                  <HMIcon name={"md-videocam"}
                                                                                          style={{
                                                                                              alignSelf: 'center',
                                                                                              // width: moderateScale(14),
                                                                                              color: listVideo.length > 0 ? Colors.colorPrimaryDark : Colors.gray,
                                                                                              fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                                                                              textAlign: 'center'
                                                                                          }}/>
                                                                              </TouchableOpacity>

                                                                          }

                                                                          {


                                                                              <TouchableOpacity
                                                                                  onPress={
                                                                                      () => listImage.length > 0 ? this.setState({
                                                                                              visibleModal: "selectSlider",
                                                                                              sliderList: listImage,
                                                                                              slider1ActiveSlide: 0
                                                                                          })
                                                                                          :
                                                                                          null

                                                                                  }

                                                                                  style={{
                                                                                      // flex: .33,
                                                                                      flexDirection: 'row',
                                                                                      alignItems: 'center',
                                                                                      justifyContent: 'center',
                                                                                      marginHorizontal: moderateScale(3)
                                                                                  }}>
                                                                                  <HMIcon name={"md-image"}
                                                                                          style={{
                                                                                              alignSelf: 'center',
                                                                                              // width: moderateScale(14),
                                                                                              color: listImage.length > 0 ? Colors.colorPrimaryDark : Colors.gray,
                                                                                              fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                                                                              textAlign: 'center'
                                                                                          }}/>
                                                                              </TouchableOpacity>

                                                                          }
                                                                          {


                                                                              <TouchableOpacity

                                                                                  onPress={
                                                                                      () => listVoice.length > 0 ? this.setState({
                                                                                              visibleModal: "selectVideo",
                                                                                              //   pathVideo: checkAudio,
                                                                                              sliderList: listVoice,

                                                                                              slider1ActiveSlide: 0,
                                                                                              // visibleModal: "selectaudio",
                                                                                              // pathAudio: checkAudio,
                                                                                          })
                                                                                          : null
                                                                                  }
                                                                                  style={{
                                                                                      // flex: .33,
                                                                                      flexDirection: 'row',
                                                                                      alignItems: 'center',
                                                                                      justifyContent: 'center',
                                                                                      //  marginHorizontal: moderateScale(5)
                                                                                  }}>
                                                                                  <HMIcon name={"md-mic"} style={{
                                                                                      alignSelf: 'center',
                                                                                      // width: moderateScale(14),
                                                                                      color: listVoice.length > 0 ? Colors.colorPrimaryDark : Colors.gray,
                                                                                      fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                                                                      textAlign: 'center'
                                                                                  }}/>
                                                                              </TouchableOpacity>

                                                                          }
                                                                          {


                                                                              <TouchableOpacity

                                                                                  onPress={
                                                                                      () => listOthers.length > 0 ? this.setState({
                                                                                              visibleModal: "selectListOthers",
                                                                                              sliderList: listOthers,
                                                                                              slider1ActiveSlide: 0,
                                                                                              // visibleModal: "selectaudio",
                                                                                              // pathAudio: checkAudio,
                                                                                          })
                                                                                          : null
                                                                                  }
                                                                                  style={{
                                                                                      // flex: .33,
                                                                                      flexDirection: 'row',
                                                                                      alignItems: 'center',
                                                                                      justifyContent: 'center',
                                                                                      marginHorizontal: moderateScale(3)
                                                                                  }}>
                                                                                  <HMIcon name={"ios-attach"}
                                                                                          style={{
                                                                                              alignSelf: 'center',
                                                                                              // width: moderateScale(14),
                                                                                              color: listOthers.length > 0 ? Colors.colorPrimaryDark : Colors.gray,
                                                                                              fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                                                                              textAlign: 'center'
                                                                                          }}/>
                                                                              </TouchableOpacity>

                                                                          }

                                                                      </View>
                                                                      {

                                                                          <View style={{
                                                                              flex: .5,
                                                                              flexDirection: 'row',
                                                                              justifyContent: 'flex-end'
                                                                          }}>
                                                                              {/!*<HMIcon name={"ios-text"} style={{*!/}
                                                                              {/!*alignSelf: 'center',*!/}
                                                                              {/!*!// width: moderateScale(14),*!/}
                                                                              {/!*color: Colors.colorDark,*!/}
                                                                              {/!*marginHorizontal: moderateScale(5),*!/}
                                                                              {/!*fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),*!/}
                                                                              {/!*textAlign: 'center'*!/}
                                                                              {/!*}}/>*!/}
                                                                              {/!*<HMTextView*!/}

                                                                              {/!*!//type={"bold"}*!/}
                                                                              {/!*noFont={!I18nManager.isRTL}*!/}
                                                                              {/!*style={{*!/}
                                                                              {/!*fontSize: moderateScale(11),*!/}
                                                                              {/!*color: Colors.gray,*!/}

                                                                              {/!*!// marginTop: moderateScale(10)*!/}
                                                                              {/!*}}*!/}
                                                                              {/!*text={item.lastWork && item.lastWork.length > 0 ? item.lastWork.length : 0}*!/}
                                                                              {/!*!//   text={"98/03/21"}*!/}
                                                                              {/!*!/>*!/}
                                                                          </View>
                                                                      }

                                                                  </View>


                                                              </View>
                                                              {/!*         </CardItem>
                                                                  </Card>*!/}
                                                          </View>
                                                      );*/
                                            }

                                            }
                                            // scrollEnabled={true}
                                            // scrollEnabled={true}

                                            // getItemLayout={(data, index) => {console.log(data, index)}
                                            //     //({length: ITEM_HEIGHT, offset: ITEM_HEIGHT * index, index})
                                            // }
                                            //  onViewableItemsChanged={this._onViewableItemsChanged}
                                            //viewabilityConfig={this._viewabilityConfig}
                                            // progressViewOffset={(a) => {
                                            // }}
                                            onScroll={(event) => {
                                                const slideSize = event.nativeEvent.layoutMeasurement.height;
                                                const index = event.nativeEvent.contentOffset.y / slideSize;
                                                const roundIndex = Math.round(index);
                                                if (roundIndex === 0) {
                                                    this._toggle(true)
                                                }

                                                if (roundIndex === 1) {
                                                    this._toggle(false)
                                                }
                                            }
                                            }
                                            onScrollToIndexFailed={(error) => {
                                                //  alert("dfgf")
                                                this.list.scrollToOffset({
                                                    offset: error.averageItemLength * error.index,
                                                    animated: true
                                                });
                                                setTimeout(() => {
                                                    if (lastWork.length !== 0 && this.list !== null) {
                                                        this.list.scrollToIndex({
                                                            index: error.index,
                                                            animated: true
                                                        });
                                                    }
                                                }, 100);
                                            }}
                                            inverted
                                        />

                                }


                            </View>
                            {/*       <View style={{width:moderateScale(1),height:moderateScale(1),backgroundColor:Colors.blackLight,}}/>*/}
                            {!this.props.token || (type === "report") || this.props.route.params.pageDetails || (item_parent?.type == 7 || type == "requestMahalehMa") ?
                                null
                                :
                                <HMBottomBarItem137
                                    funcSwitch={() =>
                                        // this.goToIndex(lastWork && lastWork.length > 0 ? lastWork.length - 1 : 0)
                                        // this._toggle(false)
                                        this.getData()
                                    }
                                    funcSend={() => NavigationService.navigateParams("SubmitSendOperationScreen", {
                                        itemExtra: item,
                                        listExtra: this.props.ListSend,
                                        //  res: data
                                    })
                                        // this.goToIndex(lastWork && lastWork.length > 0 ? lastWork.length - 1 : 0)
                                        // this._toggle(false)
                                        // this.getData()
                                    }
                                    funcChangeState={(name, data) => {
                                        this.setState({[name]: data})
                                    }}
                                    funcAddStateItemExtra={(data) => {

                                        // this.state.stateItemExtra.lastWork.unshift(this.addFlagDate([data])[0])

                                        let obj = this.state.stateItemExtra;
                                        obj["lastWork"] = this.addFlagDate(data);
                                        this.setState({
                                                stateItemExtra: obj,
                                                alaki: !this.state.alaki
                                            },
                                            () => {
                                                //  this.goToIndex(lastWork && lastWork.length > 0 ? lastWork.length - 1 : 0)

                                            });


                                    }}
                                    // funcAlaki={()=>}
                                    itemExtra={this.state.stateItemExtra}
                                    indexExtra={this.props.route.params.indexExtra}/>}

                            {!this.state.largeMap ?
                                null
                                :
                                <View style={[{
                                    width: "100%",
                                    height: "100%",
                                    position: "absolute",
                                }]}>
                                    {
                                        this.renderMap(latitude, longitude, true)
                                    }
                                    <TouchableOpacity
                                        style={{
                                            width: moderateScale(48),
                                            height: moderateScale(48),
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            padding: moderateScale(8),
                                            backgroundColor: Colors.red,
                                            borderRadius: moderateScale(24),
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                        onPress={() => {
                                            this.setState({largeMap: false})
                                        }}
                                    >
                                        <HMIcon name={"ios-close"}
                                                style={{color: Colors.white, fontSize: moderateScale(28)}}/>
                                    </TouchableOpacity>
                                </View>
                            }
                            <Popup
                                isVisible={this.state.isVisible}
                                onCancelPressed={() => this.setState({isVisible: false})}
                                onAppPressed={() => this.setState({isVisible: false})}
                                onBackButtonPressed={() => this.setState({isVisible: false})}
                                options={{
                                    latitude: latitude,
                                    longitude: longitude,
                                    // title: 'The White House',
                                    dialogTitle: i18n.t('constant.Routing'),
                                    dialogMessage: i18n.t('constant.SelectingDestination'),
                                    cancelText: i18n.t('constant.Back')
                                }}
                            />
                            {/*<Modal*/}
                            {/*isVisible={this.state.visibleModal === 'selectaudio'}*/}
                            {/*backdropColor={Colors.gray}*/}
                            {/*backdropOpacity={0.8}*/}
                            {/*animationIn="zoomInDown"*/}
                            {/*animationOut="zoomOutUp"*/}
                            {/*animationInTiming={600}*/}
                            {/*animationOutTiming={600}*/}
                            {/*backdropTransitionInTiming={600}*/}
                            {/*backdropTransitionOutTiming={600}*/}
                            {/*//style={{height: '60%'}}*/}
                            {/*onBackdropPress={() => this.hiddenModal()}*/}
                            {/*onBackButtonPress={() => this.hiddenModal()}*/}
                            {/*>*/}

                            {/*<View style={{*/}
                            {/*height: "50%",*/}
                            {/*//      padding: moderateScale(6),*/}
                            {/*backgroundColor: Colors.white*/}
                            {/*}}>*/}
                            {/*<View*/}
                            {/*style={{*/}
                            {/*flex: 1,*/}
                            {/*backgroundColor: "#2b608a",*/}
                            {/*}}>*/}

                            {/*<View style={{*/}
                            {/*justifyContent: 'center',*/}
                            {/*alignItems: 'center',*/}
                            {/*flex: 1,*/}
                            {/*}}>*/}
                            {/*<View style={{*/}
                            {/*flex: .4, alignItems: 'center',*/}
                            {/*justifyContent: 'flex-end',*/}
                            {/*}}>*/}
                            {/*/!*<Text*!/*/}
                            {/*/!*style={styles.progressText}>{Tools.getAudioTimeString(this.state.currentTime)}</Text>*!/*/}
                            {/*</View>*/}
                            {/*<View style={{flex: .6, alignItems: 'center'}}>*/}
                            {/*<TouchableOpacity*/}
                            {/*style={{*/}
                            {/*width: moderateScale(48),*/}
                            {/*height: moderateScale(48),*/}
                            {/*marginTop: moderateScale(15),*/}
                            {/*backgroundColor: Colors.white,*/}
                            {/*borderRadius: moderateScale(24),*/}
                            {/*alignItems: 'center',*/}
                            {/*justifyContent: 'center',*/}

                            {/*}}*/}
                            {/*onPress={() => {*/}
                            {/*this.switchOnPress(this.state.pathAudio)*/}
                            {/*}}*/}
                            {/*>*/}
                            {/*<Image*/}
                            {/*source={this.switchIcon(this.state.playState)}*/}
                            {/*style={{*/}
                            {/*width: moderateScale(24),*/}
                            {/*height: moderateScale(24),*/}
                            {/*tintColor: Colors.colorDark*/}
                            {/*}}/>*/}
                            {/*/!*<Text style={{position:'absolute', alignSelf:'center', marginTop:1, color:'white', fontSize:12}}>15</Text>*!/*/}
                            {/*</TouchableOpacity>*/}

                            {/*<View style={{*/}
                            {/*width: '100%',*/}
                            {/*alignItems: 'center',*/}
                            {/*justifyContent: 'center'*/}
                            {/*}}>*/}
                            {/*<Text*/}
                            {/*style={{*/}
                            {/*paddingTop: moderateScale(25),*/}
                            {/*fontSize: moderateScale(25),*/}
                            {/*color: "#fff"*/}
                            {/*}}>{Tools.getAudioTimeString(this.state.playSeconds)}</Text>*/}


                            {/*</View>*/}


                            {/*</View>*/}

                            {/*</View>*/}


                            {/*<TouchableOpacity*/}
                            {/*style={{*/}

                            {/*//    marginHorizontal: moderateScale(10),*/}
                            {/*width: moderateScale(48),*/}
                            {/*height: moderateScale(48),*/}

                            {/*justifyContent: 'center',*/}
                            {/*alignItems: 'center',*/}

                            {/*position: 'absolute',*/}
                            {/*top: 0,*/}
                            {/*right: 0,*/}
                            {/*marginTop: Platform.OS === 'ios' ? moderateScale(16) : 0*/}
                            {/*// bottom:0,*/}
                            {/*}}*/}

                            {/*onPress={*/}
                            {/*() => {*/}
                            {/*this._pause()*/}
                            {/*this.setState(*/}
                            {/*{*/}
                            {/*// ShowAudio:f,*/}
                            {/*visibleModal: '',*/}

                            {/*}*/}
                            {/*)*/}
                            {/*}*/}

                            {/*}>*/}
                            {/*<View style={{*/}
                            {/*//  flexDirection:Rtl ? 'row-reverse': 'row',*/}
                            {/*flexDirection: 'row',*/}
                            {/*alignItems: "flex-end",*/}
                            {/*//marginHorizontal: moderateScale(4)*/}
                            {/*}}>*/}
                            {/*<HMIcon name={*/}
                            {/*//Rtl ? "ios-arrow-back":'ios-arrow-forward'*/}
                            {/*I18nManager.isRTL ? "ios-arrow-back" : 'ios-arrow-forward'*/}
                            {/*// 'ios-arrow-back'*/}

                            {/*}*/}
                            {/*style={{fontSize: moderateScale(26), color: Colors.light}}/>*/}
                            {/*/!*<HMTextView text={i18n.t('constant.Back')}*!/*/}
                            {/*/!*style={{paddingLeft: moderateScale(5), color: Colors.light}}/>*!/*/}
                            {/*</View>*/}
                            {/*</TouchableOpacity>*/}

                            {/*</View>*/}

                            {/*</View>*/}
                            {/*</Modal>*/}
                            {/*{*/}
                            {/*this.state.visibleModal === 'selectVideo' ?*/}
                            {/*<View*/}
                            {/*style={{*/}
                            {/*position: 'absolute',*/}
                            {/*flex: 1,*/}
                            {/*alignContent: 'center',*/}
                            {/*alignItems: 'center',*/}
                            {/*justifyContent: 'center',*/}
                            {/*marginTop: Platform.OS === 'ios' ? moderateScale(15) : 0,*/}
                            {/*top: 0,*/}
                            {/*bottom: 0,*/}
                            {/*right: 0,*/}
                            {/*left: 0,*/}
                            {/*backgroundColor: 'rgba(0,0,0,0.7)',*/}
                            {/*zIndex: 9900*/}
                            {/*}}>*/}
                            {/*<View style={{*/}
                            {/*height: "100%",*/}
                            {/*width: '100%',*/}
                            {/*// padding: moderateScale(6),*/}
                            {/*backgroundColor: Colors.black*/}
                            {/*}}>*/}
                            {/*{*/}
                            {/*files ?*/}
                            {/*<Video*/}
                            {/*style={{flex: 1, resizeMode: 'contain'}}*/}
                            {/*autoPlay={false}*/}
                            {/*ref={(ref) => {*/}
                            {/*this.video = ref*/}
                            {/*}}*/}
                            {/*// autoPlay*/}
                            {/*//  url={checkVideo ? files.find(k => k.type === 'video/mp4').file : null}*/}
                            {/*url={this.state.pathVideo ? this.state.pathVideo : null}*/}
                            {/*title={title}*/}
                            {/*// logo={logo}*/}
                            {/*placeholder={placeholder}*/}
                            {/*//  onMorePress={() => this.onMorePress()}*/}
                            {/*onFullScreen={status => this.onFullScreen(status)}*/}
                            {/*//   fullScreenOnly*/}
                            {/*theme={theme}*/}
                            {/*/>*/}
                            {/*:*/}
                            {/*<VideoPlayer*/}
                            {/*ref={ref => this.videoPlayerRef = ref}*/}
                            {/*//  startTime={0}  // seconds*/}
                            {/*//  endTime={60}   // seconds*/}
                            {/*//    play={true}     // default false*/}
                            {/*//  replay={true}   // should player play video again if it's ended*/}
                            {/*rotate={true}   // use this prop to rotate video if it captured in landscape mode iOS only*/}
                            {/*source={video}*/}
                            {/*//   playerWidth={300} // iOS only*/}
                            {/*//  playerHeight={500} // iOS only*/}
                            {/*style={{*/}
                            {/*//backgroundColor: 'black',*/}
                            {/*flex: 1,*/}
                            {/*}}*/}
                            {/*resizeMode={VideoPlayer.typeExport.resizeMode.CONTAIN}*/}
                            {/*onChange={({nativeEvent}) => {*/}
                            {/*}} // get Current time on every second*/}
                            {/*/>*/}
                            {/*}*/}

                            {/*</View>*/}
                            {/*<TouchableOpacity*/}
                            {/*onPress={() => {*/}
                            {/*this.hiddenModal()*/}
                            {/*}}*/}

                            {/*style={{*/}
                            {/*width: moderateScale(32),*/}
                            {/*height: moderateScale(32),*/}
                            {/*// backgroundColor: '#ee005b',*/}
                            {/*position: 'absolute',*/}
                            {/*borderRadius: moderateScale(16),*/}
                            {/*margin: moderateScale(4),*/}
                            {/*top: 0,*/}
                            {/*left: 0,*/}
                            {/*alignItems: 'center',*/}
                            {/*justifyContent: 'center',*/}

                            {/*}}>*/}
                            {/*<HMIcon name={"ios-close-circle-outline"} style={{*/}
                            {/*textAlign: 'center',*/}
                            {/*//alignSelf: 'flex-end',*/}
                            {/*color: Colors.white,*/}
                            {/*// width: moderateScale(32),*/}
                            {/*// height: moderateScale(32),*/}
                            {/*fontSize: moderateScale(22)*/}
                            {/*}}/>*/}
                            {/*</TouchableOpacity>*/}
                            {/*</View>*/}
                            {/*:*/}
                            {/*null*/}
                            {/*}*/}

                            {
                                this.state.visibleModal === 'selectSlider' || this.state.visibleModal === 'selectVideo' || this.state.visibleModal === 'selectaudio' ?
                                    <View
                                        style={{
                                            position: 'absolute',
                                            flex: 1,
                                            alignContent: 'center',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginTop: Platform.OS === 'ios' ? moderateScale(15) : 0,
                                            top: 0,
                                            bottom: 0,
                                            right: 0,
                                            left: 0,
                                            backgroundColor: 'rgba(0,0,0,0.7)',
                                            zIndex: 9900
                                        }}>
                                        <View
                                            style={{
                                                height: "100%",
                                                width: '100%',
                                                // padding: moderateScale(6),
                                                backgroundColor: Colors.black,
                                                position: 'relative'
                                            }}>
                                            {
                                                <View
                                                    style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        right: 0,
                                                        left: 0,
                                                        bottom: 0,
                                                    }}

                                                >
                                                    {/*<FlatList*/}
                                                    {/*ref={(ref) => { this.flatListRef = ref }}*/}
                                                    {/*data={[1,2,3,4,5]}*/}
                                                    {/*extraData={this.state}*/}
                                                    {/*//  onScroll={(e) => this.pauseAll(e)}*/}
                                                    {/*showsHorizontalScrollIndicator={false}*/}
                                                    {/*// scrollEnabled={this.state.isPortrait}*/}
                                                    {/*horizontal={true}*/}
                                                    {/*renderAheadOffset={0}*/}
                                                    {/*initialNumToRender={5}*/}
                                                    {/*windowSize={5}*/}
                                                    {/*removeClippedSubviews={true}*/}
                                                    {/*pagingEnabled={true}*/}
                                                    {/*keyExtractor={(item, id) => id.toString()}*/}
                                                    {/*renderItem={(item, index) => (this.renderFlatlist(item, index))}*/}
                                                    {/*/>*/}
                                                    <HMSwiper
                                                        list={this.state.sliderList}
                                                        renderItem={() =>
                                                            this.state.sliderList.map((item, index) => {
                                                                let {title, description, latitude, longitude, address, code, status, files, createdtime, comment} = this.state.stateItemExtra;

                                                                return <View
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '100%'
                                                                    }}
                                                                >

                                                                    {
                                                                        this.state.visibleModal === 'selectSlider' ?
                                                                            <Image
                                                                                resizeMode={"contain"}
                                                                                style={{
                                                                                    flex: 1,
                                                                                }}
                                                                                // source={{uri: 'http://v1.qzone.cc/avatar/201407/07/00/24/53b9782c444ca987.jpg!200x200.jpg'}}
                                                                                source={{uri: item.file}}
                                                                            />
                                                                            :
                                                                            null
                                                                    }

                                                                    {
                                                                        this.state.visibleModal === 'selectVideo' || this.state.visibleModal === 'selectaudio' ?
                                                                            <HMVideo
                                                                                title={title}
                                                                                navigation={this.props.navigation}
                                                                                item={item} index={item.index}
                                                                                indexSelect={this.state.slider1ActiveSlide}
                                                                                //url={"http://techslides.com/demos/sample-videos/small.mp4"}
                                                                            />

                                                                            :
                                                                            null
                                                                    }


                                                                </View>

                                                            })
                                                        }
                                                    />
                                                    {/*          <Carousel page

                                                              ref={c => this._slider1Ref = c}
                                                              data={this.state.sliderList}
                                                        //    data={[1, 2, 3, 4, 5].}
                                                        //    data={this.state.entries}
                                                              renderItem={(item, index) => this.renderCarousel(item, index)


                                                              }
                                                        // inactiveSlideScale={.99}
                                                        // sliderWidth={sliderWidth}
                                                        // itemWidth={itemWidth}

                                                              inactiveSlideScale={1}
                                                        // sliderWidth={sliderWidth}
                                                        // itemWidth={itemWidth}

                                                              sliderWidth={Dimensions.get('window').width}
                                                              itemWidth={Dimensions.get('window').width}
                                                              hasParallaxImages={true}
                                                              firstItem={0}

                                                              inactiveSlideOpacity={0.7}
                                                        // inactiveSlideShift={20}
                                                              containerCustomStyle={styles_Carousel.slider}
                                                              contentContainerCustomStyle={styles_Carousel.sliderContentContainer}
                                                        // loop={true}
                                                        //loopClonesPerSide={1}
                                                        //    autoplay={true}
                                                        //   autoplayDelay={1000}
                                                        //   autoplayInterval={6000}
                                                              onSnapToItem={(index, item) => {
                                                                  //  alert("jvhcjk")
                                                                  //   this.pauseVideo(slider1ActiveSlide)
                                                                  // this[`video${slider1ActiveSlide}`].pause()

                                                                  // if( this.state.visibleModal === 'selectVideo' )
                                                                  // for (let i = 0; i <4 ; i++) {
                                                                  // }
                                                                  // this[`video0`].pause()
                                                                  // this[`video1`].pause()
                                                                  // this[`video2`].pause()
                                                                  // this[`video3`].pause()

                                                                  let p = "paused" + slider1ActiveSlide
                                                                  this.setState({
                                                                      [p]: true,
                                                                      slider1ActiveSlide: index
                                                                  }, () => {
                                                                  })
                                                              }
                                                              }
                                                              removeClippedSubviews={false}
                                                    />*/}
                                                </View>
                                            }
                                            {/*      <View
                                                style={{
                                                    position: 'absolute',
                                                    bottom: 0,
                                                    width: typeExport._WIDTH,
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                            >
                                                <Pagination
                                                    //  data={[1, 2, 3, 4, 5]}
                                                    dotsLength={this.state.sliderList.length}
                                                    activeDotIndex={slider1ActiveSlide}
                                                    containerStyle={styles.paginationContainer}
                                                    //  dotColor={'rgba(255, 255, 255, 0.92)'}
                                                    dotColor={Colors.colorSecondPrimary}
                                                    dotStyle={styles.paginationDot}
                                                    inactiveDotColor={Colors.white}
                                                    inactiveDotOpacity={0.4}
                                                    inactiveDotScale={0.6}
                                                    carouselRef={this._slider1Ref}
                                                    tappableDots={!!this._slider1Ref}
                                                />
                                            </View>*/}
                                        </View>
                                        <TouchableOpacity
                                            onPress={() => {
                                                this.hiddenModal()
                                            }}

                                            style={{
                                                width: moderateScale(32),
                                                height: moderateScale(32),
                                                // backgroundColor: '#ee005b',
                                                position: 'absolute',
                                                borderRadius: moderateScale(16),
                                                margin: moderateScale(4),
                                                top: 0,
                                                left: 0,
                                                alignItems: 'center',
                                                justifyContent: 'center',

                                            }}>
                                            <HMIcon name={"ios-close-circle-outline"} style={{
                                                textAlign: 'center',
                                                //alignSelf: 'flex-end',
                                                color: Colors.white,
                                                // width: moderateScale(32),
                                                // height: moderateScale(32),
                                                fontSize: moderateScale(22)
                                            }}/>
                                        </TouchableOpacity>
                                    </View>
                                    :
                                    null
                            }
                            <HMModal
                                isVisible={this.state.visibleModal === 'showDetails'}
                                backdropColor={Colors.gray}
                                backdropOpacity={0.8}
                                animationIn="zoomInDown"
                                animationOut="zoomOutUp"
                                animationInTiming={600}
                                animationOutTiming={600}
                                backdropTransitionInTiming={600}
                                backdropTransitionOutTiming={600}
                                //style={{height: '60%'}}
                                onBackdropPress={() => this.hiddenModal()}
                                onBackButtonPress={() => this.hiddenModal()}
                            >
                                {
                                    registrar ?
                                        <View
                                            style={{
                                                width: '86%',
                                                borderRadius: moderateScale(4),
                                                //  height: "90%",
                                                padding: moderateScale(6),
                                                backgroundColor: Colors.white,
                                            }}>
                                            <View style={{width: '100%', alignItems: 'center'}}>

                                                <View
                                                    style={{
                                                        flexDirection: "row",
                                                        width: "100%",
                                                        justifyContent: "space-between",
                                                        //  flexWrap: 'wrap',
                                                        //  flex: 1,
                                                        // flexGrow: 1,
                                                        //   lineHeight: moderateScale(10),
                                                    }}>
                                                    <View
                                                        style={{
                                                            flexDirection: "row",
                                                            marginHorizontal: moderateScale(2),
                                                        }}>
                                                        <HMTextView type={"bold"}
                                                                    noFont={!I18nManager.isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(14),
                                                                        color: Colors.blackLight,
                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={"نام اپراتور :"}
                                                            //   text={"98/03/21"}
                                                        />
                                                        <HMTextView type={"bold"}
                                                                    noFont={!I18nManager.isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(13),
                                                                        color: Colors.colorDark,
                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={registrar.FirstName + " " + registrar.LastName}
                                                            //   text={"98/03/21"}
                                                        />
                                                    </View>
                                                    <View
                                                        style={{
                                                            flexDirection: "row",
                                                            marginHorizontal: moderateScale(2)
                                                        }}>
                                                        <HMTextView type={"bold"}
                                                                    noFont={!I18nManager.isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(14),
                                                                        color: Colors.blackLight,
                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    text={"شماره محله :"}
                                                            //   text={"98/03/21"}
                                                        />
                                                        <HMTextView type={"bold"}
                                                                    noFont={!I18nManager.isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(13),
                                                                        color: Colors.colorDark,

                                                                    }}
                                                                    text={registrar.CodePlace}
                                                            //   text={"98/03/21"}
                                                        />
                                                    </View>
                                                </View>
                                                <View
                                                    style={{
                                                        width: '100%', flexDirection: "row",
                                                        marginHorizontal: moderateScale(2),
                                                        marginTop: moderateScale(6)
                                                    }}>
                                                    <HMTextView type={"bold"}
                                                                noFont={!I18nManager.isRTL}
                                                                style={{
                                                                    fontSize: moderateScale(14),
                                                                    color: Colors.blackLight,
                                                                    // marginTop: moderateScale(10)
                                                                }}
                                                                text={"آدرس :"}
                                                        //   text={"98/03/21"}
                                                    />
                                                    <HMTextView type={"bold"}
                                                                noFont={!I18nManager.isRTL}
                                                                style={{
                                                                    fontSize: moderateScale(13),
                                                                    color: Colors.colorDark,
                                                                }}
                                                                text={registrar.Place}
                                                        //   text={"98/03/21"}
                                                    />
                                                </View>
                                                <View
                                                    style={{
                                                        width: '100%', flexDirection: "row",
                                                        marginHorizontal: moderateScale(2),
                                                        marginTop: moderateScale(6)
                                                    }}>
                                                    <HMTextView type={"bold"}
                                                                noFont={!I18nManager.isRTL}
                                                                style={{
                                                                    fontSize: moderateScale(14),
                                                                    color: Colors.blackLight,
                                                                    // marginTop: moderateScale(10)
                                                                }}
                                                                text={"شماره همراه :"}
                                                        //   text={"98/03/21"}
                                                    />
                                                    <HMTextView type={"bold"}
                                                                noFont={!I18nManager.isRTL}
                                                                style={{
                                                                    fontSize: moderateScale(13),
                                                                    color: Colors.colorDark,
                                                                }}
                                                                text={registrar.Mobile}
                                                        //   text={"98/03/21"}
                                                    />
                                                </View>

                                            </View>


                                        </View>
                                        :
                                        null
                                }

                            </HMModal>
                            <HMModal
                                isVisible={this.state.visibleModal === 'selectListOthers'}
                                backdropColor={Colors.gray}
                                backdropOpacity={0.8}
                                animationIn="zoomInDown"
                                animationOut="zoomOutUp"
                                animationInTiming={600}
                                animationOutTiming={600}
                                backdropTransitionInTiming={600}
                                backdropTransitionOutTiming={600}
                                //style={{height: '60%'}}
                                onBackdropPress={() => this.hiddenModal()}
                                onBackButtonPress={() => this.hiddenModal()}
                            >

                                <View style={{
                                    //  height: "90%",
                                    padding: moderateScale(6),
                                    backgroundColor: Colors.white,
                                }}>
                                    <View style={{width: '100%', alignItems: 'center'}}>
                                        <HMTextView

                                            //type={"bold"}
                                            //   noFont={!I18nManager.isRTL}
                                            style={{
                                                fontSize: moderateScale(11),
                                                color: Colors.colorPrimary,


                                                // marginTop: moderateScale(10)
                                            }}
                                            // text={item.status}
                                            text={i18n.t('constant.Files')}
                                            //   text={"98/03/21"}
                                        />
                                    </View>
                                    <HMFlatList

                                        data={this.state.sliderList}
                                        renderItem={({item, index}) =>
                                            <View style={{
                                                // width: "100%",
                                                flex: 1,
                                                marginHorizontal: moderateScale(10),
                                                //  marginVertical: moderateScale(2),
                                                // padding: moderateScale(6)
                                            }}>

                                                <TouchableOpacity
                                                    onPress={() => {
                                                        Tools.GoLink(item.file)
                                                    }}
                                                    style={{
                                                        //paddingVertical: moderateScale(10),
                                                        //  width: '100%',
                                                        alignItems: 'center',
                                                        flexDirection: 'row',
                                                        flex: 1,
                                                        padding: moderateScale(6)
                                                    }}
                                                >

                                                    <View


                                                        style={{
                                                            flex: .2
                                                            //   width: moderateScale(32),
                                                            // height: moderateScale(32),
                                                            // backgroundColor: '#ee005b',
                                                            //  position: 'absolute',
                                                            //   borderRadius: moderateScale(16),
                                                            //margin: moderateScale(4),
                                                            //   top: 0,
                                                            //   left: 0,

                                                            //  justifyContent: 'center',

                                                        }}>
                                                        <HMIcon name={"ios-attach"} style={{
                                                            textAlign: 'center',
                                                            //alignSelf: 'flex-end',
                                                            color: Colors.gray,
                                                            // width: moderateScale(32),
                                                            // height: moderateScale(32),
                                                            fontSize: moderateScale(22)
                                                        }}/>


                                                    </View>

                                                    <View style={{flex: .8}}>
                                                        <HMTextView

                                                            //type={"bold"}
                                                            //   noFont={!I18nManager.isRTL}
                                                            style={{
                                                                fontSize: moderateScale(11),
                                                                color: Colors.colorDark,

                                                                // marginTop: moderateScale(10)
                                                            }}
                                                            // text={item.status}
                                                            text={item.file}
                                                            //   text={"98/03/21"}
                                                        />
                                                    </View>

                                                </TouchableOpacity>

                                            </View>
                                        }
                                    />


                                </View>
                            </HMModal>
                            {
                                !this.state.largeMap ?
                                    <Animated.View
                                        style={{
                                            top: focusedAnim.interpolate({
                                                //  inputRange: [0, 0.5, 0.51, 0.7, 1],
                                                inputRange: [0, 0.5, 0.51, 0.7, 1],
                                                outputRange: [
                                                    moderateScale(-50),
                                                    moderateScale(0),
                                                    -0,
                                                    -0,
                                                    100,
                                                ],
                                            }),
                                        }}

                                    >
                                        <TouchableOpacity
                                            onPress={() => {
                                                this._toggle(true);
                                                if (Platform.OS === "ios")
                                                    this.list.scrollToIndex({index: 0, animated: true});
                                                else
                                                    this.list.scrollToEnd({animated: true});
                                                // this.setState({
                                                //     visibleModal: true
                                                // })
                                            }}
                                            style={{
                                                position: 'absolute',
                                                bottom: moderateScale(0),
                                                overflow: 'hidden',
                                                width: moderateScale(48),
                                                height: moderateScale(48),
                                                borderRadius: moderateScale(24),
                                                // padding: moderateScale(4),
                                                margin: moderateScale(5),
                                                borderWidth: moderateScale(1),
                                                borderColor: Colors.colorSecondPrimary,
                                                borderBottomWidth: 0,
                                                shadowColor: '#000',
                                                shadowOffset: {width: 0, height: moderateScale(.7)},
                                                shadowOpacity: 0.6,
                                                shadowRadius: moderateScale(2),
                                                elevation: moderateScale(1),
                                                // marginLeft: moderateScale(1),
                                                // marginRight: moderateScale(1),
                                                // marginTop: moderateScale(1),
                                                // marginBottom: moderateScale(1),
                                                backgroundColor: Colors.colorSecondPrimary,
                                                alignItems: 'center',
                                                justifyContent: "center"
                                            }}

                                        >
                                            <HMIcon name="chevron-down" style={{
                                                color: Colors.white,
                                                fontSize: moderateScale(28),
                                                //  padding: moderateScale(4),
                                                alignSelf: "center",
                                            }}/>
                                        </TouchableOpacity>
                                    </Animated.View>
                                    :
                                    null
                            }

                            {
                                this.props.NoInternetDialog ?
                                    <DialogConnectionCustomize
                                        onPress={() => this.getData()}
                                    />
                                    :
                                    null
                            }
                            {
                                this.props.isLoading || this.props.isLoadingSet ?
                                    <DialogLoadingCustomize/>
                                    : null
                            }

                        </View>


                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    renderMap(latitude, longitude, type) {
        // return null;
        return <HMMap


            ref={ref => (this.map = ref)}
            styleMap={this.state.largeMap ? {

                width: "100%",
                height: "100%",
            } : {
                width: moderateScale(110),
                height: moderateScale(110),
            }}
            style={[{
                width: "100%",
                //height:height-moderateScale(200),
                height: "100%",
                marginBottom: this.state.marginBottom
            },
                // !type?{bottom: -25}:{}
            ]}
            showPlace
            initialRegion={{
                latitude: parseFloat(latitude),
                longitude: parseFloat(longitude),
                latitudeDelta: type ? 0.0015 : 0.0035,
                longitudeDelta: type ? 0.00121 : 0.00321,
            }}
            coordinate={{
                latitude: parseFloat(latitude),
                longitude: parseFloat(longitude),
                latitudeDelta: type ? 0.0015 : 0.0035,
                longitudeDelta: type ? 0.00121 : 0.00321,
            }}
            zoom={type ? 20 : 14.7}
            typeMap={!type}
            //application
            pitchEnabled={type}

            rotateEnabled={type}

            scrollEnabled={type}

            zoomEnabled={type}

            //web
            zoomControl={type}
            doubleClickZoom={type}
            closePopupOnClick={type}
            dragging={type}
            zoomSnap={type}
            zoomDelta={type}
            trackResize={type}
            touchZoom={type}
            scrollWheelZoom={type}

            showWrap={true}

            attributionControl={type}
        >

        </HMMap>
    }


    renderFiles(files, indexParent, audioNormal) {
        return <View
            style={{
                //position:'absolute',
                flexDirection: "row",
                flexWrap: 'wrap',
                flex: 1,

                flexGrow: 1,
                alignItems: "center",
                //  alignItems: 'center', justifyContent: 'center',
                //  backgroundColor: _main ? "#eee" : Colors.transparent,
                //  backgroundColor: "#876a79",
            }}>


            {
                files && files.length > 0 ?
                    (files).map((item, key) => {
                        //let f = String(files[key].type);
                        let f = String(item.type);
                        if (f.search('audio/') >= 0) {
                            if (audioNormal)
                                return <TouchableOpacity
                                    style={{
                                        width: moderateScale(60),
                                        height: moderateScale(60),
                                        // width: moderateScale(200),
                                        // height: moderateScale(40),
                                        margin: moderateScale(4)
                                    }}
                                    onPress={() => {
                                        this.setState({
                                            visibleModal: "selectVideo",
                                            //   pathVideo: checkAudio,
                                            sliderList: [item],

                                            slider1ActiveSlide: 0,
                                            // visibleModal: "selectaudio",
                                            // pathAudio: checkAudio,
                                        })
                                    }}
                                >
                                    {/*   <View
                                    style={{
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        marginHorizontal: moderateScale(8)
                                    }}>


                                    <HMIcon
                                        type={"Feather"}
                                        name={"align-center"}
                                        style={{
                                            // width: moderateScale(10),
                                            // height: moderateScale(40),
                                            textAlign: 'center',
                                            margin: -moderateScale(10),
                                            padding: -moderateScale(10),
                                            //alignSelf: 'flex-end',
                                            color: Colors.blackLight,
                                            // width: moderateScale(32),
                                            // height: moderateScale(32),
                                            fontSize: moderateScale(26),
                                            transform: [{rotate: '90deg'}],
                                        }}
                                        //size={40}
                                        // style={{
                                        //     flex: 0,
                                        //     width: moderateScale(20),
                                        //     height: moderateScale(20),
                                        //     alignSelf: 'center',
                                        //     alignItems: 'center',
                                        //     justifyContent: 'center',
                                        //     textAlign: 'center',
                                        //     backgroundColor: '#e24c4b',
                                        //     color: 'white',
                                        //     margin: -6,
                                        //     padding: -6,
                                        //
                                        //     fontSize: moderateScale(20),
                                        //     transform: [{ rotate: '90deg'}],
                                        // }}
                                    />

                                    <HMIcon
                                        type={"Feather"}
                                        name={"align-center"}
                                        style={{
                                            // width: moderateScale(10),
                                            // height: moderateScale(40),
                                            textAlign: 'center',
                                            marginEnd: -moderateScale(10),
                                            paddingEnd: -moderateScale(10),
                                            //alignSelf: 'flex-end',
                                            color: Colors.blackLight,
                                            // width: moderateScale(32),
                                            // height: moderateScale(32),
                                            fontSize: moderateScale(26),
                                            transform: [{rotate: '270deg'}],
                                        }}/>

                                    <HMIcon
                                        type={"Feather"}
                                        name={"align-center"}
                                        style={{
                                            // width: moderateScale(10),
                                            // height: moderateScale(40),
                                            textAlign: 'center',
                                            marginEnd: -moderateScale(10),
                                            paddingEnd: -moderateScale(10),
                                            //alignSelf: 'flex-end',
                                            color: Colors.blackLight,
                                            // width: moderateScale(32),
                                            // height: moderateScale(32),
                                            fontSize: moderateScale(26),
                                            transform: [{rotate: '90deg'}],
                                        }}/>

                                    <HMIcon
                                        type={"Feather"}
                                        name={"align-center"}
                                        style={{
                                            // width: moderateScale(10),
                                            // height: moderateScale(40),
                                            textAlign: 'center',
                                            marginEnd: -moderateScale(10),
                                            paddingEnd: -moderateScale(10),
                                            //alignSelf: 'flex-end',
                                            color: Colors.blackLight,
                                            // width: moderateScale(32),
                                            // height: moderateScale(32),
                                            fontSize: moderateScale(26),
                                            transform: [{rotate: '270deg'}],
                                        }}/>

                                    <HMIcon
                                        type={"Feather"}
                                        name={"align-center"}
                                        style={{
                                            //  width: moderateScale(40),
                                            // height: moderateScale(40),
                                            textAlign: 'center',
                                            //alignSelf: 'flex-end',
                                            color: Colors.blackLight,
                                            // width: moderateScale(32),
                                            // height: moderateScale(32),
                                            fontSize: moderateScale(26),
                                            transform: [{rotate: '90deg'}],
                                        }}/>


                                    <HMIcon
                                        name={"play"}
                                        style={{
                                            //  width: moderateScale(40),
                                            // height: moderateScale(40),
                                            textAlign: 'center',
                                            //alignSelf: 'flex-end',
                                            color: Colors.blue,
                                            // width: moderateScale(32),
                                            // height: moderateScale(32),
                                            fontSize: moderateScale(26)
                                        }}/>
                                </View>*/}

                                    <View


                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            padding: moderateScale(4),
                                            borderWidth: moderateScale(1),
                                            borderRadius: moderateScale(2),
                                            borderColor: '#ddd',
                                            borderBottomWidth: 0,
                                            shadowColor: '#000',
                                            shadowOffset: {
                                                width: 0,
                                                height: moderateScale(.8)
                                            },
                                            shadowOpacity: 0.6,
                                            shadowRadius: moderateScale(2),
                                            elevation: moderateScale(1),
                                            marginLeft: moderateScale(1),
                                            marginRight: moderateScale(1),
                                            marginTop: moderateScale(1),
                                            marginBottom: moderateScale(1),
                                            backgroundColor: Colors.blackLight,
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>


                                        <View

                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                paddingVertical: moderateScale(10),
                                                //backgroundColor: '#96a7ee',
                                                //  width: moderateScale(40),
                                                //height: moderateScale(40),
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >

                                            <HMIcon
                                                type={"MaterialCommunityIcons"}
                                                name={"account-tie-voice"}
                                                style={{
                                                    //  width: moderateScale(40),
                                                    // height: moderateScale(40),
                                                    textAlign: 'center',
                                                    //alignSelf: 'flex-end',
                                                    color: Colors.white,
                                                    // width: moderateScale(32),
                                                    // height: moderateScale(32),
                                                    fontSize: moderateScale(26)
                                                }}/>

                                        </View>


                                    </View>
                                </TouchableOpacity>
                            else
                                return <HMVoicePlayer

                                    key={key} index={indexParent}
                                    SeekBarCheck={true}
                                    indexSelect={this.state.indexSelectVoice}
                                    audioRefExtra={this.state.audioRefExtra}
                                    itemExtra={item}
                                    duration={item.duration}
                                    path={item.file} onPress={(func, audioRef) => {
                                    this.setState({
                                        indexSelectVoice: indexParent,
                                        audioRefExtra: audioRef
                                    }, () => {
                                        func ? func() : null
                                    })
                                }}/>

                        }


                        else if (f.search('image/') >= 0)
                            return <TouchableOpacity
                                key={key + "_" + indexParent}
                                style={{
                                    width: moderateScale(60),
                                    height: moderateScale(60),
                                    margin: moderateScale(4)
                                }}
                                onPress={() => {
                                    this.setState({
                                        visibleModal: "selectSlider",
                                        sliderList: [item],
                                        slider1ActiveSlide: 0
                                    })
                                }}
                            >
                                <HMImageView
                                    resizeMode={'cover'}
                                    uriComplete={item.file}
                                    _backgroundColorLoading={Colors.black}
                                    styleImage={{
                                        //  resizeMode: 'cover',
                                        width: "100%",
                                        height: "100%",
                                        //   backgroundColor: "#ee7e0c",
                                        //  borderTopRightRadius:moderateScale(8),
                                        //  borderTopEndRadius: moderateScale(12),
                                        //  borderTopStartRadius: moderateScale(8),
                                    }}
                                    //  onLoad={this._onLoad}
                                    //   onError={status !== 3 ? this._onError : undefined} // prevent infinite-loop bug
                                />
                            </TouchableOpacity>
                        else if (f.search('video/') >= 0)
                            return <TouchableOpacity
                                style={{
                                    width: moderateScale(60),
                                    height: moderateScale(60),
                                    margin: moderateScale(4)
                                }}
                                onPress={() => {
                                    this.setState({
                                        visibleModal: "selectVideo",
                                        // pathVideo: checkVideo,
                                        sliderList: [item],

                                        slider1ActiveSlide: 0
                                    })
                                }}
                            >


                                <View


                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        padding: moderateScale(4),
                                        borderWidth: moderateScale(1),
                                        borderRadius: moderateScale(2),
                                        borderColor: '#ddd',
                                        borderBottomWidth: 0,
                                        shadowColor: '#000',
                                        shadowOffset: {
                                            width: 0,
                                            height: moderateScale(.8)
                                        },
                                        shadowOpacity: 0.6,
                                        shadowRadius: moderateScale(2),
                                        elevation: moderateScale(1),
                                        marginLeft: moderateScale(1),
                                        marginRight: moderateScale(1),
                                        marginTop: moderateScale(1),
                                        marginBottom: moderateScale(1),
                                        backgroundColor: Colors.blackLight,
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>


                                    <View

                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            paddingVertical: moderateScale(10),
                                            //backgroundColor: '#96a7ee',
                                            //  width: moderateScale(40),
                                            //height: moderateScale(40),
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >

                                        <HMIcon
                                            name={"play"}
                                            style={{
                                                //  width: moderateScale(40),
                                                // height: moderateScale(40),
                                                textAlign: 'center',
                                                //alignSelf: 'flex-end',
                                                color: Colors.white,
                                                // width: moderateScale(32),
                                                // height: moderateScale(32),
                                                fontSize: moderateScale(26)
                                            }}/>

                                    </View>


                                </View>
                            </TouchableOpacity>

                        else {


                            return <TouchableOpacity
                                style={{
                                    width: moderateScale(60),
                                    height: moderateScale(60),
                                    margin: moderateScale(4)
                                }}
                                onPress={() => {
                                    this.setState({
                                        visibleModal: "selectListOthers",
                                        sliderList: [item],
                                        slider1ActiveSlide: 0,
                                        // visibleModal: "selectaudio",
                                        // pathAudio: checkAudio,
                                    })
                                }}
                            >


                                <View


                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        padding: moderateScale(4),
                                        borderWidth: moderateScale(1),
                                        borderRadius: moderateScale(2),
                                        borderColor: '#ddd',
                                        borderBottomWidth: 0,
                                        shadowColor: '#000',
                                        shadowOffset: {
                                            width: 0,
                                            height: moderateScale(.8)
                                        },
                                        shadowOpacity: 0.6,
                                        shadowRadius: moderateScale(2),
                                        elevation: moderateScale(1),
                                        marginLeft: moderateScale(1),
                                        marginRight: moderateScale(1),
                                        marginTop: moderateScale(1),
                                        marginBottom: moderateScale(1),
                                        backgroundColor: Colors.blackLight,
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>


                                    <View

                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            paddingVertical: moderateScale(10),
                                            //backgroundColor: '#96a7ee',
                                            //  width: moderateScale(40),
                                            //height: moderateScale(40),
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                    >

                                        <HMIcon
                                            name={"attach"}
                                            style={{
                                                //  width: moderateScale(40),
                                                // height: moderateScale(40),
                                                textAlign: 'center',
                                                //alignSelf: 'flex-end',
                                                color: Colors.white,
                                                // width: moderateScale(32),
                                                // height: moderateScale(32),
                                                fontSize: moderateScale(26)
                                            }}/>

                                    </View>


                                </View>
                            </TouchableOpacity>
                        }


                    })
                    :
                    null
            }

        </View>
    }

    renderDetails() {
        let data = this.state.stateItemExtra;
        let {ListStateChange} = this.state;
        let {title, description, latitude, longitude, address, code, status, files, createdtime, comment, video, audio, image, subject, date, category, lastWork, messageid} = this.state.stateItemExtra;
        let {item, type, indexExtra, pageDetails, item_parent} = this.props.route.params;
        // pageDetails = item.type == 7 ? false : (pageDetails ? pageDetails : !(lastWork && lastWork.length > 0));
        pageDetails = item_parent?.type == 7 || type == "requestMahalehMa" ? true : (pageDetails ? pageDetails : !(lastWork && lastWork.length > 0));

        //   return null;
        return <View style={{width: "100%",}}>

            <View
                style={{
                    width: "100%",
                    padding: moderateScale(2),
                    marginVertical: moderateScale(4)
                }}>
                <View
                    style={[{
                        width: "100%",

                        borderWidth: moderateScale(1),
                        borderColor: "#814646",
                        borderRadius: moderateScale(6),
                        padding: moderateScale(4),
                        overflow: "hidden",
                        marginTop: moderateScale(28)

                    },
                        //   !this.state.more ? {height: moderateScale(200),} : {}
                    ]}>
                    <View style={{
                        flex: 1,
                        flexDirection: 'row',
                        alignItems: "center",
                        justifyContent: "center",
                        marginVertical: moderateScale(8)
                    }}>
                        <View style={{flexDirection: 'row', flex: .33,}}>
                            <HMTextView type={"bold"}
                                        noFont={!I18nManager.isRTL}
                                        style={{
                                            fontSize: moderateScale(14),
                                            marginHorizontal: moderateScale(5),
                                            color: Colors.blackLight,
                                            // marginTop: moderateScale(10)
                                        }}
                                // text={"1423578"}
                                        text={data.messageno ? data.messageno : "-"}
                                //   text={"98/03/21"}
                            />
                        </View>
                        <View
                            style={{
                                flex: .33, flexDirection: 'row',
                                // alignItems: 'center',
                                justifyContent: 'center'
                                //    backgroundColor:'#96ee5b'
                            }}>
                            {

                                <HMTextView type={"bold"}
                                            noFont={!I18nManager.isRTL}
                                            style={{
                                                fontSize: moderateScale(14),
                                                color: data.color ? data.color : Colors.gray,
                                                // marginTop: moderateScale(10)
                                            }}
                                            text={data.status}
                                    //   text={"98/03/21"}
                                />

                            }
                        </View>
                        <View style={{flexDirection: 'row', flex: .33, justifyContent: 'flex-end'}}>

                            <TouchableOpacity
                                onPress={() => {
                                    Tools.GoLink(data.mobile, "phone")
                                }}
                                style={{flexDirection: 'row',}}>

                                <HMTextView
                                    type={"bold"}
                                    noFont={!I18nManager.isRTL}

                                    style={{
                                        fontSize: moderateScale(14),

                                        color: Colors.blue,
                                        // marginHorizontal:moderateScale(1)
                                        // marginTop: moderateScale(10)
                                    }}
                                    text={data.mobile}
                                    //   text={"98/03/21"}
                                />
                                {/* <HMIcon name={"md-call"} style={{
                                        alignSelf: 'center',
                                        // width: moderateScale(14),
                                        color: Colors.blue,
                                        fontSize: Platform.OS === 'ios' ? moderateScale(14) : moderateScale(12),
                                        textAlign: 'center'
                                    }}/>*/}
                            </TouchableOpacity>
                        </View>
                    </View>
                    <View style={{width: '100%', flexDirection: "row"}}>
                        {
                            latitude && latitude != null && latitude != '' ?
                                <TouchableOpacity
                                    style={
                                        {
                                            width: moderateScale(110),
                                            height: moderateScale(110),

                                            borderWidth: moderateScale(1),
                                            borderColor: Colors.colorDark,
                                            borderRadius: moderateScale(6),
                                            overflow: "hidden"
                                        }
                                    }
                                    onPress={() => {
                                        this.setState({
                                            largeMap: !this.state.largeMap
                                        })
                                    }}
                                >
                                    {

                                        this.state.largeMap ?
                                            null
                                            :
                                            this.renderMap(latitude, longitude, false)

                                    }


                                </TouchableOpacity>
                                : null
                        }
                        <View style={{flex: 1}}>

                            {/*   <View style={{
                                width: "100%",
                                flexDirection: "row",
                                justifyContent: "space-between",
                            }}>
                                <HMListItemTitle
                                    backgroundColorTitle={Colors.transparent}
                                    backgroundColor={Colors.transparent}
                                    // title={"معرفی دوستان"}
                                    styleRoot={{marginTop: moderateScale(0)}}
                                    text={i18n.t('constant.TaskTitle')}
                                    title={item.subject}
                                    iconName={"book-outline"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        //   this.onShare()
                                    }}
                                />
                                <HMListItemTitle
                                    backgroundColorTitle={Colors.transparent}
                                    backgroundColor={Colors.transparent}
                                    // title={"معرفی دوستان"}
                                    styleRoot={{marginTop: moderateScale(0)}}
                                    text={"ثبت کننده :"}
                                    wrap={true}
                                    title={item.subject}
                                    styleText={{color: Colors.gray}}
                                    styleTitle={{color: Colors.blue}}

                                    //  iconName={"book-outline"}

                                    NoShowIconOnpress
                                    onPress={() => {
                                        //   this.onShare()
                                    }}
                                />
                            </View>*/}
                            <HMListItemTitle
                                backgroundColorTitle={Colors.transparent}
                                backgroundColor={Colors.transparent}
                                // title={"معرفی دوستان"}
                                styleRoot={{
                                    marginTop: moderateScale(0),

                                }}
                                text={i18n.t('constant.Description')}
                                title={item.description}

                                //   image={require("../../assets/img/add-friend.png")}
                                iconName={"clipboard-text-outline"}
                                iconType={"MaterialCommunityIcons"}
                                NoShowIconOnpress
                                onPress={() => {
                                    //   this.onShare()
                                }}
                                //_svgUri={"https://app.iran137.com/images/svg/w3c-logo.svg"}
                                // _svgUri={"https://app.iran137.com/images/svg/exchange.svg"}
                                //_svgUri={"https://app.iran137.com/images/svg/plus2.svg"}
                                // _svgUri={"https://app.iran137.com/images/svg/homer-simpson.svg"}
                                //_svgUri={"http://thenewcode.com/assets/images/thumbnails/homer-simpson.svg"}
                            />
                            <TouchableOpacity
                                style={{width: "100%", flexDirection: 'row'}}
                                onPress={() => {
                                    latitude && latitude != null && latitude != '' ? this.setState({
                                            largeMap: !this.state.largeMap
                                        })
                                        :
                                        null
                                }}
                            >

                                {
                                    <View

                                        style={{
                                            //flex: .3,
                                            flexDirection: 'row',
                                            width: moderateScale(30),
                                            height: moderateScale(30),
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            padding: moderateScale(4),
                                            marginHorizontal: moderateScale(10),
                                            // marginHorizontal: moderateScale(5)
                                        }}

                                    >
                                        <HMIcon type={"Feather"} name={"map-pin"} style={{
                                            alignSelf: 'center',
                                            // width: moderateScale(14),
                                            color: latitude && latitude != null && latitude != '' ? Colors.blue : Colors.blackLight,
                                            fontSize: Platform.OS === 'ios' ? moderateScale(28) : moderateScale(26),
                                            textAlign: 'center'
                                        }}/>
                                    </View>
                                    // latitude && latitude != null && latitude != '' ?
                                    //     <TouchableOpacity
                                    //         style={
                                    //             {
                                    //                 // width: moderateScale(100),
                                    //                 // height: moderateScale(80),
                                    //                 width: moderateScale(38),
                                    //                 height: moderateScale(38),
                                    //                 // borderWidth: moderateScale(1),
                                    //                 // borderColor: Colors.colorDark,
                                    //                 //  borderRadius: moderateScale(6),
                                    //                 overflow: "hidden"
                                    //             }
                                    //         }
                                    //         onPress={() => {
                                    //             this.setState({
                                    //                 largeMap: !this.state.largeMap
                                    //             })
                                    //         }}
                                    //     >
                                    //         {
                                    //
                                    //             this.state.largeMap ?
                                    //             null
                                    //             :
                                    //             this.renderMap(latitude, longitude, false)
                                    //
                                    //         }
                                    //
                                    //
                                    //     </TouchableOpacity>
                                    //     : null
                                }

                                <View
                                    style={{
                                        flex: 1,
                                        padding: moderateScale(4),
                                        justifyContent: 'center'
                                    }}>

                                    <HMTextView

                                        type={"bold"}
                                        noFont={!I18nManager.isRTL}
                                        style={{
                                            fontSize: moderateScale(12),
                                            color: Colors.colorDarkText,

                                            // marginTop: moderateScale(10)
                                        }}
                                        //text={'اراک خ هپکو خ امام حسین'}
                                        text={address}
                                        //   text={"98/03/21"}
                                    />

                                </View>


                            </TouchableOpacity>

                        </View>
                    </View>
                    <View
                        style={{
                            width: "100%",
                            // display: this.state.more? null : "none"
                            display: pageDetails ? null : "none"
                        }}
                    >

                        <HMTextView type={"bold"}
                            //   text={i18n.t('constant.signIn')}
                                    text={type === "report" ? "اطلاعات" : i18n.t('constant.Task')}
                                    styleRoot={{
                                        alignSelf: 'center',
                                        marginHorizontal: moderateScale(10),
                                        marginTop: moderateScale(4)
                                    }}
                                    style={{
                                        color: Colors.blackLight,
                                        fontSize: moderateScale(13),


                                        //marginEnd: moderateScale(10)
                                    }}/>
                        <HMListItemTitle
                            backgroundColorTitle={Colors.gray}

                            // title={"معرفی دوستان"}
                            styleRoot={{marginTop: moderateScale(4)}}
                            text={i18n.t('constant.MessageGroup')}
                            title={item.group ? item.group : item.groupassigned}


                            //   image={require("../../assets/img/add-friend.png")}
                            image={"md-clipboard"}
                            NoShowIconOnpress
                            onPress={() => {
                                //   this.onShare()
                            }}
                        />
                        <HMListItemTitle
                            backgroundColorTitle={Colors.gray}

                            // title={"معرفی دوستان"}
                            styleRoot={{marginTop: moderateScale(4)}}
                            text={i18n.t('constant.DegreeImportance')}
                            title={item.importance}

                            //   image={require("../../assets/img/add-friend.png")}
                            image={"md-clipboard"}
                            NoShowIconOnpress
                            onPress={() => {
                                //   this.onShare()
                            }}
                        />
                        <HMListItemTitle
                            backgroundColorTitle={Colors.gray}

                            // title={"معرفی دوستان"}
                            styleRoot={{marginTop: moderateScale(4)}}
                            styleTitle={{color: item.color ? item.color : Colors.colorDark}}
                            text={i18n.t('constant.Status')}
                            title={item.status}

                            //   image={require("../../assets/img/add-friend.png")}
                            image={"md-clipboard"}
                            NoShowIconOnpress
                            onPress={() => {
                                //   this.onShare()
                            }}
                        />
                        {
                            item.registrar ?
                                <HMListItemTitle
                                    backgroundColorTitle={Colors.gray}

                                    // title={"معرفی دوستان"}
                                    styleRoot={{marginTop: moderateScale(4)}}
                                    styleTitle={{color: Colors.blue}}
                                    text={"نام ثبت کننده"}
                                    title={item.registrar.FirstName + " " + item.registrar.LastName}
                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-clipboard"}
                                    NoShowIconOnpress
                                    file={'link'}

                                    onPressChild={() => {
                                        this.setState({
                                            visibleModal: "showDetails"
                                        })
                                        //   this.onShare()
                                    }}
                                />
                                :
                                null

                        }


                        {
                            type === "report" ?
                                null
                                :
                                <View style={{width: "100%"}}>

                                    <HMListItemTitle
                                        backgroundColorTitle={Colors.gray}

                                        // title={"معرفی دوستان"}
                                        styleRoot={{marginTop: moderateScale(4)}}
                                        text={i18n.t('constant.TaskStartTime')}
                                        title={item.date_start}

                                        //   image={require("../../assets/img/add-friend.png")}
                                        image={"md-clipboard"}
                                        NoShowIconOnpress
                                        onPress={() => {
                                            //   this.onShare()
                                        }}
                                    />
                                    <HMListItemTitle
                                        backgroundColorTitle={Colors.gray}

                                        // title={"معرفی دوستان"}
                                        styleRoot={{marginTop: moderateScale(4)}}
                                        text={i18n.t('constant.EndTask')}
                                        title={item.date_end}

                                        //   image={require("../../assets/img/add-friend.png")}
                                        image={"md-clipboard"}
                                        NoShowIconOnpress
                                        onPress={() => {
                                            //   this.onShare()
                                        }}
                                    />

                                    <HMListItemTitle
                                        backgroundColorTitle={Colors.gray}

                                        // title={"معرفی دوستان"}
                                        styleRoot={{marginTop: moderateScale(4)}}
                                        text={i18n.t('constant.TaskType')}
                                        title={item.tasktype}

                                        //   image={require("../../assets/img/add-friend.png")}
                                        image={"md-clipboard"}
                                        NoShowIconOnpress
                                        onPress={() => {
                                            //   this.onShare()
                                        }}
                                    />
                                </View>
                        }

                        <HMListItemTitle
                            backgroundColorTitle={Colors.gray}

                            // title={"معرفی دوستان"}
                            styleRoot={{marginTop: moderateScale(4)}}
                            text={i18n.t('constant.TaskReference')}
                            title={item.assigned}

                            //   image={require("../../assets/img/add-friend.png")}
                            image={"md-clipboard"}
                            NoShowIconOnpress
                            onPress={() => {
                                //   this.onShare()
                            }}
                        />
                        {
                            type === "report" ?
                                null
                                :
                                <HMListItemTitle
                                    backgroundColorTitle={Colors.gray}

                                    // title={"معرفی دوستان"}
                                    styleRoot={{marginTop: moderateScale(4)}}
                                    text={i18n.t('constant.SourceTaskCreation')}
                                    title={item.source}

                                    //   image={require("../../assets/img/add-friend.png")}
                                    image={"md-clipboard"}
                                    NoShowIconOnpress
                                    onPress={() => {
                                        //   this.onShare()
                                    }}
                                />
                        }

                        {/*   <HMListItemTitle
                                            backgroundColorTitle={Colors.gray}
                                            text={i18n.t('constant.WorkOrderPrint')}
                                            title={checkImage ? i18n.t('constant.View') : null}
                                            file={"link"}
                                            path={checkImage ? checkImage : null}
                                            //   image={require("../../assets/img/add-friend.png")}
                                            image={"md-image"}
                                            styleRoot={{marginTop: moderateScale(4)}}

                                            NoShowIconOnpress
                                            onPressChild={() => {
                                                Tools.GoLink("http://portal.arak.ir/index.php?module=HelpDesk&action=PrintInfo&mode=getRequestData&id=29258")
                                                //   this.onShare()
                                            }}
                                        />*/}

                        <HMTextView type={"bold"}
                            //   text={i18n.t('constant.signIn')}
                                    text={i18n.t('constant.apply')}
                                    styleRoot={{
                                        alignSelf: 'center',
                                        marginHorizontal: moderateScale(10),
                                        marginTop: moderateScale(4)
                                    }}
                                    style={{
                                        color: Colors.blackLight,
                                        fontSize: moderateScale(13),


                                        //marginEnd: moderateScale(10)
                                    }}/>

                        <HMListItemTitle
                            backgroundColorTitle={Colors.gray}

                            // title={"معرفی دوستان"}
                            styleRoot={{marginTop: moderateScale(4)}}
                            text={i18n.t('constant.MessageNumber')}
                            title={item.messageno}

                            //   image={require("../../assets/img/add-friend.png")}
                            image={"md-clipboard"}
                            NoShowIconOnpress
                            onPress={() => {
                                //   this.onShare()
                            }}
                        />
                        <HMListItemTitle
                            backgroundColorTitle={Colors.gray}

                            // title={"معرفی دوستان"}
                            styleRoot={{marginTop: moderateScale(4)}}
                            text={i18n.t('constant.title')}
                            title={item.title}

                            //   image={require("../../assets/img/add-friend.png")}
                            image={"md-clipboard"}
                            NoShowIconOnpress
                            onPress={() => {
                                //   this.onShare()
                            }}
                        />

                        <HMListItemTitle
                            backgroundColorTitle={Colors.gray}

                            // title={"معرفی دوستان"}
                            styleRoot={{marginTop: moderateScale(4)}}
                            text={i18n.t('constant.Citizen')}
                            title={item.contact}

                            //   image={require("../../assets/img/add-friend.png")}
                            image={"md-clipboard"}
                            NoShowIconOnpress
                            onPress={() => {
                                //   this.onShare()
                            }}
                        />
                        <HMListItemTitle
                            backgroundColorTitle={Colors.gray}

                            // title={"معرفی دوستان"}
                            styleRoot={{marginTop: moderateScale(4)}}
                            text={i18n.t('constant.address')}
                            title={item.address}

                            //   image={require("../../assets/img/add-friend.png")}
                            image={"md-clipboard"}
                            NoShowIconOnpress
                            onPress={() => {
                                //   this.onShare()
                            }}
                        />
                        <HMListItemTitle
                            backgroundColorTitle={Colors.gray}

                            // title={"معرفی دوستان"}
                            styleRoot={{marginTop: moderateScale(4)}}
                            text={i18n.t('constant.phoneNumber')}
                            title={item.mobile}
                            file={'link'}
                            //   image={require("../../assets/img/add-friend.png")}
                            image={"md-clipboard"}
                            NoShowIconOnpress
                            onPressChild={() => {
                                Tools.GoLink(item.mobile, "phone")
                                //   this.onShare()
                            }}
                        />
                        <HMListItemTitle
                            backgroundColorTitle={Colors.gray}

                            // title={"معرفی دوستان"}
                            file={'link'}
                            styleRoot={{marginTop: moderateScale(4)}}
                            text={i18n.t('constant.phone')}
                            title={item.tel}

                            //   image={require("../../assets/img/add-friend.png")}
                            image={"md-clipboard"}
                            NoShowIconOnpress
                            onPressChild={() => {
                                Tools.GoLink(item.tel, "phone")
                                //   this.onShare()
                            }}
                        />
                        <View style={{
                            backgroundColor: Colors.white,
                            borderRadius: moderateScale(8),
                            margin: moderateScale(moderateScale(4))
                        }}>
                            {this.renderFiles(files)}
                        </View>
                        {/*

                                                    <HMListItemTitle
                                                        backgroundColorTitle={Colors.gray}
                                                        text={i18n.t('constant.Image')}
                                                        title={this.state.listImage.length > 0 ? i18n.t('constant.View') : null}
                                                        file={"aaaa"}
                                                        path={this.state.listImage.length > 0 ? this.state.listImage : null}
                                                        //   image={require("../../assets/img/add-friend.png")}
                                                        image={"md-image"}
                                                        styleRoot={{marginTop: moderateScale(4)}}

                                                        NoShowIconOnpress
                                                        onPress={() => {
                                                            //   this.onShare()
                                                        }}
                                                        onPressChild={
                                                            () => this.setState({
                                                                visibleModal: "selectSlider",
                                                                // pathVideo: checkVideo
                                                                sliderList: this.state.listImage
                                                            })
                                                        }
                                                    />
                                                    <HMListItemTitle
                                                        backgroundColorTitle={Colors.gray}
                                                        text={i18n.t('constant.Video')}
                                                        title={this.state.listVideo.length > 0 ? i18n.t('constant.View') : null}
                                                        file={"video"}
                                                        //  path={checkImage ? checkImage : null}
                                                        //   image={require("../../assets/img/add-friend.png")}
                                                        image={"md-image"}
                                                        styleRoot={{marginTop: moderateScale(4)}}
                                                        onPressChild={
                                                            () => this.setState({
                                                                visibleModal: "selectVideo",
                                                                //  pathVideo: checkVideo,
                                                                sliderList: this.state.listVideo,
                                                                slider1ActiveSlide: 0

                                                            })
                                                        }
                                                        NoShowIconOnpress
                                                        onPress={() => {
                                                            //   this.onShare()
                                                        }}
                                                    />
                                                    <HMListItemTitle
                                                        backgroundColorTitle={Colors.gray}
                                                        text={i18n.t('constant.Voice')}
                                                        title={this.state.listVoice.length > 0 ? i18n.t('constant.View') : null}
                                                        file={"video"}
                                                        path={this.state.listVoice.length > 0 ? this.state.listVoice : null}
                                                        //   image={require("../../assets/img/add-friend.png")}
                                                        image={"md-image"}
                                                        styleRoot={{marginTop: moderateScale(4)}}
                                                        onPressChild={
                                                            () => this.setState({
                                                                visibleModal: "selectaudio",
                                                                //  pathVideo: checkAudio,
                                                                sliderList: this.state.listVoice,

                                                                slider1ActiveSlide: 0
                                                                // visibleModal: "selectaudio",
                                                                // pathAudio: checkAudio
                                                            }, () => {
                                                            })
                                                        }
                                                        NoShowIconOnpress
                                                        onPress={() => {
                                                            //   this.onShare()
                                                        }}
                                                    />
                                                    <HMListItemTitle
                                                        backgroundColorTitle={Colors.gray}
                                                        text={i18n.t('constant.Files')}
                                                        title={this.state.listOthers.length > 0 ? i18n.t('constant.View') : null}
                                                        file={"others"}
                                                        path={this.state.listOthers.length > 0 ? this.state.listOthers : null}
                                                        //   image={require("../../assets/img/add-friend.png")}
                                                        image={"md-image"}
                                                        styleRoot={{marginTop: moderateScale(4)}}
                                                        onPressChild={
                                                            () => this.setState({
                                                                visibleModal: "selectSlider",
                                                                //  pathVideo: checkAudio,
                                                                sliderList: this.state.listOthers,

                                                                slider1ActiveSlide: 0
                                                                // visibleModal: "selectaudio",
                                                                // pathAudio: checkAudio
                                                            })
                                                        }
                                                        NoShowIconOnpress
                                                        onPress={() => {
                                                            //   this.onShare()
                                                        }}
                                                    />*/}
                    </View>
                    <View
                        style={{
                            width: "100%",
                            //    position: "absolute",
                            //   bottom: 0,
                            alignSelf: 'center',
                            flexDirection: "row",
                            justifyContent: "space-between",
                            paddingHorizontal: moderateScale(4),
                            marginTop: moderateScale(6)
                        }}>
                        <HMTextView
                            type={"bold"}
                            text={item.time}
                            styleRoot={{
                                alignSelf: 'center',
                                marginHorizontal: moderateScale(10),
                                marginTop: moderateScale(4)
                            }}
                            style={{
                                color: Colors.colorDark,
                                fontSize: moderateScale(13),


                                //marginEnd: moderateScale(10)
                            }}/>

                        {pageDetails ?
                            null
                            :
                            <View style={{flex: 1, flexDirection: 'row', justifyContent: "center"}}>
                                {
                                    //
                                    // <View
                                    //     style={{
                                    //     //flex: .3,
                                    //     flexDirection: 'row',
                                    //
                                    //     alignItems: 'center',
                                    //     justifyContent: 'center',
                                    //     marginHorizontal: moderateScale(5)
                                    // }}>
                                    //     <HMIcon
                                    //         type={"Feather"}
                                    //         name={"map-pin"} style={{
                                    //         alignSelf: 'center',
                                    //         // width: moderateScale(14),
                                    //         color: data.latitude && data.latitude != null && data.latitude != '' ? Colors.colorPrimaryDark : Colors.gray,
                                    //         fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                    //         textAlign: 'center'
                                    //     }}/>
                                    // </View>
                                    //
                                    //
                                }

                                {

                                    <View style={{
                                        // flex: .33,

                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginHorizontal: moderateScale(5)
                                    }}>
                                        <HMIcon name={"md-image"} style={{
                                            alignSelf: 'center',
                                            // width: moderateScale(14),
                                            color: ((data.files && data.files.length > 0) || data.image) ? Colors.colorPrimaryDark : Colors.gray,
                                            fontSize: Platform.OS === 'ios' ? moderateScale(20) : moderateScale(18),
                                            textAlign: 'center'
                                        }}/>
                                    </View>

                                }
                                {


                                    <View style={{
                                        // flex: .33,
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginHorizontal: moderateScale(5)
                                    }}>
                                        <HMIcon name={"md-videocam"} style={{
                                            alignSelf: 'center',
                                            // width: moderateScale(14),
                                            color: ((data.files && data.files.length > 0) || data.video) ? Colors.colorPrimaryDark : Colors.gray,
                                            fontSize: Platform.OS === 'ios' ? moderateScale(20) : moderateScale(18),
                                            textAlign: 'center'
                                        }}/>
                                    </View>

                                }
                                {


                                    <View style={{
                                        // flex: .33,
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginHorizontal: moderateScale(5)
                                    }}>
                                        <HMIcon name={"md-mic"} style={{
                                            alignSelf: 'center',
                                            // width: moderateScale(14),
                                            color: ((data.files && data.files.length > 0) || data.audio) ? Colors.colorPrimaryDark : Colors.gray,
                                            fontSize: Platform.OS === 'ios' ? moderateScale(20) : moderateScale(18),
                                            textAlign: 'center'
                                        }}/>
                                    </View>

                                }

                            </View>
                        }
                        {
                            pageDetails ?
                                null
                                :
                                <TouchableOpacity
                                    onPress={() => {

                                        NavigationService.navigateKeyDynamic("DetailsOperatorApplyScreen", {
                                            item: item,
                                            type: type,
                                            indexExtra: indexExtra,
                                            pageDetails: true
                                        })
                                        // this.setState({
                                        //     more: !this.state.more
                                        // })
                                    }}
                                >
                                    <HMTextView
                                        type={"bold"}
                                        text={this.state.more ? "کمتر" : "بیشتر"}
                                        styleRoot={{
                                            alignSelf: 'center',
                                            marginHorizontal: moderateScale(10),
                                            marginTop: moderateScale(4)
                                        }}
                                        style={{
                                            color: Colors.blue,
                                            fontSize: moderateScale(13),


                                            //marginEnd: moderateScale(10)
                                        }}/>
                                </TouchableOpacity>
                        }

                    </View>
                </View>

                <View
                    style={[{
                        position: "absolute",
                        top: 0,
                        alignSelf: 'center',
                        width: moderateScale(130),
                        height: moderateScale(36),
                        backgroundColor: Colors.blackLight,
                        borderRadius: moderateScale(12),
                        justifyContent: 'center',
                        alignItems: 'center',
                    }]}>
                    <HMTextView

                        type={"bold"}
                        noFont={!I18nManager.isRTL}
                        style={{
                            fontSize: moderateScale(14),
                            color: Colors.white,
                            textAlign: "center",
                            // marginTop: moderateScale(10)
                        }}
                        //text={'اراک خ هپکو خ امام حسین'}
                        text={item.date ? item.date : item.createdtime}
                        //   text={"98/03/21"}
                    />
                </View>

            </View>
            {/*

                                        {
                                            latitude && latitude != null && latitude != '' ?
                                                <HMDetailsMap
                                                    position={{latitude: latitude, longitude: longitude}}/>
                                                : null
                                        }
*/}


            {
                // latitude && latitude != null && latitude != '' ?
                //     <View>
                //         <View
                //             onPress={() => {
                //             }
                //                 /*  NavigationService.navigateParams("MapShowScreen", {
                //                    //   latitude: data.latitude, longitude: data.longitude
                //                   })*/
                //             } style={{
                //             width: "100%",
                //             //height: moderateScale(200)
                //             height: (this.state.widthOriginal > 600) ? 430 : (Platform.OS === "web" ? this.state.widthOriginal : typeExport.WIDTH) / 1.6
                //
                //         }}>
                //             <HMMap
                //                 ref={ref => (this.map = ref)}
                //                 style={{
                //                     width: "100%",
                //                     //height:height-moderateScale(200),
                //                     height: "100%",
                //                     marginBottom: this.state.marginBottom
                //                 }}
                //                 showPlace
                //                 initialRegion={{
                //                     latitude: parseFloat(latitude),
                //                     longitude: parseFloat(longitude),
                //                     latitudeDelta: 0.015,
                //                     longitudeDelta: 0.0121,
                //                 }}
                //                 coordinate={{
                //                     latitude: parseFloat(latitude),
                //                     longitude: parseFloat(longitude),
                //                     latitudeDelta: 0.015,
                //                     longitudeDelta: 0.0121,
                //                 }}
                //
                //             >
                //                 {/*   <MapView.Marker coordinate={{
                //                     latitude: parseFloat(latitude),
                //                     longitude: parseFloat(longitude),
                //                     latitudeDelta: 0.015,
                //                     longitudeDelta: 0.0121,
                //                 }}/>*/}
                //
                //             </HMMap>
                //
                //             {
                //                 // address ?
                //                 1 === 1 ?
                //                     <TouchableOpacity
                //                         onPress={() => this.onFlyToPress(parseFloat(longitude), parseFloat(latitude))}
                //                         style={{
                //                             flexDirection: "row",
                //                             padding: moderateScale(5),
                //                             //     justifyContent: "flex-end",
                //                             alignItems: "center",
                //                             width: "100%",
                //                             backgroundColor: "rgba(0, 0, 0, 0.4)",
                //                             position: "absolute",
                //                             bottom: 0,
                //                             left: 0
                //                         }}>
                //                         <HMIcon type={"Feather"}                                                 name={"map-pin"}
                //                                 style={{
                //                                     marginEnd: moderateScale(10),
                //                                     fontSize: moderateScale(22),
                //                                     color: Colors.white
                //                                 }}/>
                //                         <HMTextView
                //
                //                             type={"bold"}
                //                             noFont={!I18nManager.isRTL}
                //                             style={{
                //                                 fontSize: moderateScale(12),
                //                                 color: Colors.light3,
                //
                //                                 // marginTop: moderateScale(10)
                //                             }}
                //                             //text={'اراک خ هپکو خ امام حسین'}
                //                             text={address}
                //                             //   text={"98/03/21"}
                //                         />
                //
                //                     </TouchableOpacity>
                //                     :
                //                     null
                //             }
                //
                //             <TouchableOpacity
                //
                //                 onPress={() => {
                //                     Platform.OS === 'android' ?
                //                         Tools.GoLink(`geo:${latitude},${longitude}`)
                //                         : this.setState({
                //                             /*   lat: this.state.regionFeature ? this.state.regionFeature.geometry.coordinates[1] : this.state.lat,
                //                                long: this.state.regionFeature ? this.state.regionFeature.geometry.coordinates[0] : this.state.long, */
                //
                //                             lat: latitude,
                //                             long: longitude,
                //                             isVisible: true
                //                         })
                //                 }}
                //                 style={{
                //                     position: 'absolute',
                //                     margin: moderateScale(4),
                //                     alignItems: 'center',
                //                     justifyContent: 'center',
                //                     top: 0,
                //                     left: 0,
                //                     height: moderateScale(38),
                //                     width: moderateScale(38),
                //                     borderRadius: moderateScale(19),
                //                     backgroundColor: Colors.colorPrimary
                //                 }}>
                //                 <HMIcon
                //                     name={"location"}
                //                     type="Entypo"
                //                     style={{
                //                         fontSize: moderateScale(20),
                //                         color: Colors.white,
                //                         textAlign: "center",
                //                         padding: moderateScale(4),
                //
                //                     }}/>
                //
                //             </TouchableOpacity>
                //
                //         </View>
                //         <HMDetailsMap
                //             position={{latitude: latitude, longitude: longitude}}/>
                //
                //     </View>
                //     : null
            }

            {
                // !this.props.token || (type === "report") ?
                //     null
                //     :
                //     <TouchableOpacity
                //         style={{
                //             backgroundColor: Colors.colorPrimary,
                //             width: "96%",
                //             height: moderateScale(40),
                //             alignSelf: 'center',
                //             alignItems: "center",
                //             justifyContent: "center",
                //             marginTop: moderateScale(8),
                //             borderRadius: moderateScale(6)
                //             // borderRadius:moderateScale(2)
                //         }}
                //         onPress={() => {
                //             this.getData()
                //
                //         }}
                //     >
                //         <View style={{
                //             flexDirection: "row",
                //             alignItems: "center",
                //             justifyContent: "center"
                //         }}>
                //             <HMTextView type={"bold"}
                //                 //   text={i18n.t('constant.signIn')}
                //                         text={i18n.t('constant.Switching')}
                //
                //                         style={{
                //                             color: "white",
                //                             fontSize: moderateScale(13),
                //                             //marginEnd: moderateScale(10)
                //                         }}/>
                //
                //         </View>
                //     </TouchableOpacity>

            }

            {/*Expert*/}
            {
                !pageDetails ?
                    null :

                    <HMFlatList

                        // ItemSeparatorComponent={
                        //     <View style={{
                        //         width: '100%',
                        //         height: moderateScale(1),
                        //         backgroundColor: '#4f4f4f'
                        //     }}/>
                        // }
                        // data={lastWork === null || !lastWork ? [] : lastWork}
                        // extraData={lastWork}
                        ref={(ref) => {
                            //this.list = ref.flatListRef.current;
                            this.list = ref && ref.flatListRef?.current;
                        }}
                        extraData={this.state}
                        keyExtractor={(item, index) => index.toString() + (lastWork?.length)}

                        data={lastWork === null || !lastWork ? [] : lastWork}
                        // style={{transform: [{scaleY: -1}]}}
                        // initialScrollIndex={1}
                        renderItem={({item: itemLastWork, index: indexLastWork}) => {
                            let {files} = itemLastWork;
                            let checkType = (itemLastWork.type != "mine");
                            // let resultDataSplit = this.state.arrayDate.find(obj => obj.date_split = itemLastWork.date_split);
                            // let checkAudio = audio || audio === null ? audio : (files && files.length > 0 && (files.find(k => k.type === 'audio/aac')) && (files.find(k => k.type === 'audio/aac')).file)
                            // let checkImage = image || image === null ? image : (files && files.length > 0 && (files.find(k => k.type === 'image/jpeg')) && (files.find(k => k.type === 'image/jpeg')).file)
                            // let checkVideo = video || video === null ? video : (files && files.length > 0 && (files.find(k => k.type === 'video/mp4')) && (files.find(k => k.type === 'video/mp4')).file)
                            //
                            // let listVoice = [];
                            // let listImage = [];
                            // let listVideo = [];
                            // let listOthers = [];
                            // if (files)
                            //     for (let i = 0; i < files.length; i++) {
                            //         let f = String(files[i].type);
                            //
                            //         if (f.search('audio/') >= 0)
                            //             listVoice.push(files[i])
                            //
                            //         else if (f.search('image/') >= 0)
                            //             listImage.push(files[i])
                            //
                            //         else if (f.search('video/') >= 0)
                            //             listVideo.push(files[i])
                            //         else {
                            //             listOthers.push(files[i])
                            //         }
                            //
                            //     }

                            // if (!this.state.arrayDate || this.state.arrayDate.length === 0) {
                            //     //   dateFinal = itemLastWork.date_split;
                            //     this.state.arrayDate.push(itemLastWork)
                            // }
                            // else if (!resultDataSplit) {
                            //     //  dateFinal = itemLastWork.date_split;
                            //     this.state.arrayDate.push(itemLastWork)
                            // }

                            return (
                                <View key={indexLastWork}
                                      style={{
                                          width: "100%",
                                          //transform: [{scaleY: -1}]
                                      }}
                                >

                                    {
                                        !itemLastWork.flagDate ?
                                            null
                                            :
                                            <View
                                                style={{

                                                    alignSelf: 'center',
                                                    width: moderateScale(130),
                                                    height: moderateScale(36),
                                                    backgroundColor: Colors.blackLight,
                                                    borderRadius: moderateScale(12),
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    marginTop: moderateScale(8)
                                                }}>

                                                <HMTextView

                                                    type={"bold"}
                                                    noFont={!I18nManager.isRTL}
                                                    style={{
                                                        fontSize: moderateScale(14),
                                                        color: Colors.white,

                                                        // marginTop: moderateScale(10)
                                                    }}
                                                    //text={'اراک خ هپکو خ امام حسین'}
                                                    text={itemLastWork.date_split}
                                                    //   text={"98/03/21"}
                                                />
                                            </View>

                                    }

                                    <View
                                        style={{
                                            width: "90%",
                                            backgroundColor: checkType ? Colors.white : "#effdde",
                                            borderRadius: moderateScale(10),
                                            marginVertical: moderateScale(4),
                                            alignSelf: checkType ? "flex-end" : "flex-start",
                                            alignItems: checkType ? "flex-end" : "flex-start"

                                        }}>
                                        {/*         <HMTextView

                                                                    type={"bold"}
                                                                    noFont={!I18nManager.isRTL}
                                                                    style={{
                                                                        fontSize: moderateScale(18),
                                                                        color: Colors.blackLight,

                                                                        // marginTop: moderateScale(10)
                                                                    }}
                                                                    //text={'اراک خ هپکو خ امام حسین'}
                                                                    text={indexLastWork + ""}
                                                                    //   text={"98/03/21"}
                                                                />*/}
                                        {
                                            checkType ?
                                                <View
                                                    style={{
                                                        flex: 1,
                                                        // width: '100%',
                                                        flexDirection: "row",
                                                        justifyContent: "flex-end",
                                                        alignItems: "center",
                                                        padding: moderateScale(4)
                                                    }}>

                                                    <HMTextView

                                                        //  type={"bold"}
                                                        noFont={!I18nManager.isRTL}
                                                        style={{
                                                            fontSize: moderateScale(12),
                                                            color: itemLastWork.color ? itemLastWork.color : Colors.colorDarkText,
                                                            margin: moderateScale(6)

                                                            // marginTop: moderateScale(10)
                                                        }}
                                                        text={itemLastWork.user ? itemLastWork.user : ""}
                                                    />
                                                    <HMTextView

                                                        type={"bold"}
                                                        noFont={!I18nManager.isRTL}
                                                        style={{
                                                            fontSize: moderateScale(13),
                                                            color: itemLastWork.color ? Colors.white : Colors.colorDarkText,
                                                            margin: moderateScale(6)

                                                            // marginTop: moderateScale(10)
                                                        }}
                                                        text={itemLastWork.role ? itemLastWork.role : ""}
                                                        styleRoot={[itemLastWork.color && itemLastWork.role ? {
                                                            borderRadius: moderateScale(16),
                                                            backgroundColor: itemLastWork.color,
                                                            marginHorizontal: moderateScale(4),
                                                        } : {}]}
                                                    />
                                                    <View style={{
                                                        width: moderateScale(48),
                                                        height: moderateScale(48),
                                                        borderRadius: moderateScale(24),
                                                        borderColor: Colors.gray,
                                                        borderWidth: moderateScale(1)
                                                    }}>
                                                        <HMImageView
                                                            _backgroundColorLoading={Colors.transparent}
                                                            //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                                            uriComplete={itemLastWork.image}
                                                            styleText={{marginTop: moderateScale(10)}}
                                                            borderRadius={4}
                                                        />
                                                    </View>


                                                </View>
                                                :
                                                null
                                        }

                                        {
                                            item.title ?
                                                <HMTextView

                                                    type={"bold"}
                                                    noFont={!I18nManager.isRTL}
                                                    style={{
                                                        fontSize: moderateScale(14),
                                                        color: Colors.blackLight,
                                                        margin: moderateScale(6)

                                                        // marginTop: moderateScale(10)
                                                    }}
                                                    text={itemLastWork.title ? itemLastWork.title : ""}
                                                />
                                                :
                                                null

                                        }


                                        <HMTextView

                                            type={"bold"}
                                            noFont={!I18nManager.isRTL}
                                            style={{
                                                fontSize: moderateScale(14),
                                                color: Colors.colorDarkText,
                                                margin: moderateScale(6)

                                                // marginTop: moderateScale(10)
                                            }}
                                            text={itemLastWork.comment ? itemLastWork.comment : ""}
                                        />


                                        {this.renderFiles(files, indexLastWork)}


                                        <HMTextView

                                            // type={"bold"}
                                            noFont={!I18nManager.isRTL}
                                            style={{
                                                fontSize: moderateScale(12),
                                                color: Colors.colorDarkText,
                                                margin: moderateScale(6)

                                                // marginTop: moderateScale(10)
                                            }}
                                            text={itemLastWork.time ? itemLastWork.time : ""}
                                            styleRoot={{
                                                width: "100%",
                                                flexDirection: "row",
                                                justifyContent: !checkType ? "flex-start" : "flex-end"
                                            }}
                                        />
                                    </View>
                                </View>
                            );
                            /*      return (
                                      <View
                                          style={{
                                              flex: 1,
                                              marginVertical: moderateScale(4),
                                              backgroundColor: Colors.white,
                                              marginHorizontal: moderateScale(10),
                                              //  marginVertical: moderateScale(2),
                                              // padding: moderateScale(6)
                                          }}>
                                          {/!*     <Card>
                                                  <CardItem cardBody style={{
                                                      paddingLeft: 0,
                                                      paddingRight: 0,
                                                      paddingTop: 0,
                                                      paddingBottom: 0,
                                                  }}>*!/}
                                          <View
                                              style={{
                                                  //paddingVertical: moderateScale(10),
                                                  width: '100%',

                                                  padding: moderateScale(6)
                                              }}
                                          >


                                              <View style={{
                                                  flexDirection: 'row',
                                                  alignSelf: "center",
                                                  width: '100%'
                                              }}>
                                                  <View style={{flex: .6}}>
                                                      <HMTextView

                                                          type={"bold"}
                                                          //   noFont={!I18nManager.isRTL}
                                                          style={{
                                                              fontSize: moderateScale(12),
                                                              color: Colors.colorDark,

                                                              // marginTop: moderateScale(10)
                                                          }}
                                                          text={item.user + (item.role ? ` ( ${item.role} ) ` : "")}
                                                          //   text={"98/03/21"}
                                                      />

                                                  </View>

                                                  <View
                                                      style={{
                                                          flex: .4,
                                                          flexDirection: 'row',
                                                          justifyContent: 'flex-end'
                                                      }}>
                                                      <HMTextView

                                                          //type={"bold"}
                                                          noFont={!I18nManager.isRTL}
                                                          style={{
                                                              fontSize: moderateScale(11),
                                                              color: Colors.colorDarkText,


                                                              // marginTop: moderateScale(10)
                                                          }}
                                                          text={item.date}
                                                      />
                                                  </View>


                                              </View>

                                              <View
                                                  style={{
                                                      flexDirection: 'row',
                                                      flex: 1,
                                                      marginVertical: moderateScale(6),
                                                      marginHorizontal: moderateScale(3)
                                                  }}>
                                                  <HMTextView

                                                      type={"bold"}
                                                      noFont={!I18nManager.isRTL}
                                                      style={{
                                                          fontSize: moderateScale(12),
                                                          color: item.color ? item.color : Colors.colorDarkText,

                                                          // marginTop: moderateScale(10)
                                                      }}
                                                      text={item.status}
                                                  />


                                              </View>
                                              <View
                                                  style={{
                                                      flexDirection: 'row',
                                                      width: "100%",

                                                      marginBottom: moderateScale(6),
                                                      marginHorizontal: moderateScale(3)
                                                  }}>

                                                  <HMTextView

                                                      // type={"bold"}
                                                      //   noFont={!I18nManager.isRTL}
                                                      style={{
                                                          fontSize: moderateScale(12),
                                                          color: Colors.colorDark,

                                                          // marginTop: moderateScale(10)
                                                      }}
                                                      text={item.comment ? item.comment : ""}
                                                      //   text={"98/03/21"}
                                                      styleRoot={{
                                                          //  flexDirection: "row",
                                                          flex: 1,
                                                          //  width:'100%',
                                                          //   justifyContent: "flex-end",
                                                          flexWrap: 'wrap',

                                                      }}
                                                  />
                                              </View>
                                              {/!*   <View style={{
                                              width: '100%',
                                              height: moderateScale(1),
                                              backgroundColor: '#4f4f4f'
                                          }}/>*!/}
                                              <View style={{width: "100%", flexDirection: 'row',}}>
                                                  <View style={{
                                                      flex: .5,
                                                      flexDirection: 'row',
                                                  }}>


                                                      {/!*{*!/}

                                                      {/!*<Lightbox*!/}
                                                      {/!*renderContent={() => (*!/}
                                                      {/!*<View style={{*!/}
                                                      {/!*width: typeExport.WIDTH,*!/}
                                                      {/!*height: typeExport.HEIGHT*!/}
                                                      {/!*}}>*!/}
                                                      {/!*{*!/}
                                                      {/!*<Image*!/}
                                                      {/!*style={{*!/}
                                                      {/!*flex: 1,*!/}
                                                      {/!*resizeMode: 'contain'*!/}
                                                      {/!*}}*!/}
                                                      {/!*source={{uri: checkImage}}*!/}
                                                      {/!*!/>*!/}

                                                      {/!*}*!/}

                                                      {/!*</View>*!/}
                                                      {/!*)}>*!/}
                                                      {/!*<HMIcon name={"md-image"} style={{*!/}
                                                      {/!*alignSelf: 'center',*!/}
                                                      {/!*!// width: moderateScale(14),*!/}
                                                      {/!*color: checkImage ? Colors.colorPrimaryDark : Colors.gray,*!/}
                                                      {/!*fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),*!/}
                                                      {/!*textAlign: 'center'*!/}
                                                      {/!*}}/>*!/}

                                                      {/!*</Lightbox>*!/}


                                                      {/!*}*!/}
                                                      {


                                                          <TouchableOpacity
                                                              onPress={
                                                                  () => listVideo.length > 0 ? this.setState({
                                                                          visibleModal: "selectVideo",
                                                                          // pathVideo: checkVideo,
                                                                          sliderList: listVideo,

                                                                          slider1ActiveSlide: 0
                                                                      })

                                                                      :
                                                                      null
                                                              }

                                                              style={{
                                                                  // flex: .33,
                                                                  flexDirection: 'row',
                                                                  alignItems: 'center',
                                                                  justifyContent: 'center',
                                                                  marginHorizontal: moderateScale(3)
                                                              }}>
                                                              <HMIcon name={"md-videocam"}
                                                                      style={{
                                                                          alignSelf: 'center',
                                                                          // width: moderateScale(14),
                                                                          color: listVideo.length > 0 ? Colors.colorPrimaryDark : Colors.gray,
                                                                          fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                                                          textAlign: 'center'
                                                                      }}/>
                                                          </TouchableOpacity>

                                                      }

                                                      {


                                                          <TouchableOpacity
                                                              onPress={
                                                                  () => listImage.length > 0 ? this.setState({
                                                                          visibleModal: "selectSlider",
                                                                          sliderList: listImage,
                                                                          slider1ActiveSlide: 0
                                                                      })
                                                                      :
                                                                      null

                                                              }

                                                              style={{
                                                                  // flex: .33,
                                                                  flexDirection: 'row',
                                                                  alignItems: 'center',
                                                                  justifyContent: 'center',
                                                                  marginHorizontal: moderateScale(3)
                                                              }}>
                                                              <HMIcon name={"md-image"}
                                                                      style={{
                                                                          alignSelf: 'center',
                                                                          // width: moderateScale(14),
                                                                          color: listImage.length > 0 ? Colors.colorPrimaryDark : Colors.gray,
                                                                          fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                                                          textAlign: 'center'
                                                                      }}/>
                                                          </TouchableOpacity>

                                                      }
                                                      {


                                                          <TouchableOpacity

                                                              onPress={
                                                                  () => listVoice.length > 0 ? this.setState({
                                                                          visibleModal: "selectVideo",
                                                                          //   pathVideo: checkAudio,
                                                                          sliderList: listVoice,

                                                                          slider1ActiveSlide: 0,
                                                                          // visibleModal: "selectaudio",
                                                                          // pathAudio: checkAudio,
                                                                      })
                                                                      : null
                                                              }
                                                              style={{
                                                                  // flex: .33,
                                                                  flexDirection: 'row',
                                                                  alignItems: 'center',
                                                                  justifyContent: 'center',
                                                                  //  marginHorizontal: moderateScale(5)
                                                              }}>
                                                              <HMIcon name={"md-mic"} style={{
                                                                  alignSelf: 'center',
                                                                  // width: moderateScale(14),
                                                                  color: listVoice.length > 0 ? Colors.colorPrimaryDark : Colors.gray,
                                                                  fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                                                  textAlign: 'center'
                                                              }}/>
                                                          </TouchableOpacity>

                                                      }
                                                      {


                                                          <TouchableOpacity

                                                              onPress={
                                                                  () => listOthers.length > 0 ? this.setState({
                                                                          visibleModal: "selectListOthers",
                                                                          sliderList: listOthers,
                                                                          slider1ActiveSlide: 0,
                                                                          // visibleModal: "selectaudio",
                                                                          // pathAudio: checkAudio,
                                                                      })
                                                                      : null
                                                              }
                                                              style={{
                                                                  // flex: .33,
                                                                  flexDirection: 'row',
                                                                  alignItems: 'center',
                                                                  justifyContent: 'center',
                                                                  marginHorizontal: moderateScale(3)
                                                              }}>
                                                              <HMIcon name={"ios-attach"}
                                                                      style={{
                                                                          alignSelf: 'center',
                                                                          // width: moderateScale(14),
                                                                          color: listOthers.length > 0 ? Colors.colorPrimaryDark : Colors.gray,
                                                                          fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),
                                                                          textAlign: 'center'
                                                                      }}/>
                                                          </TouchableOpacity>

                                                      }

                                                  </View>
                                                  {

                                                      <View style={{
                                                          flex: .5,
                                                          flexDirection: 'row',
                                                          justifyContent: 'flex-end'
                                                      }}>
                                                          {/!*<HMIcon name={"ios-text"} style={{*!/}
                                                          {/!*alignSelf: 'center',*!/}
                                                          {/!*!// width: moderateScale(14),*!/}
                                                          {/!*color: Colors.colorDark,*!/}
                                                          {/!*marginHorizontal: moderateScale(5),*!/}
                                                          {/!*fontSize: Platform.OS === 'ios' ? moderateScale(16) : moderateScale(14),*!/}
                                                          {/!*textAlign: 'center'*!/}
                                                          {/!*}}/>*!/}
                                                          {/!*<HMTextView*!/}

                                                          {/!*!//type={"bold"}*!/}
                                                          {/!*noFont={!I18nManager.isRTL}*!/}
                                                          {/!*style={{*!/}
                                                          {/!*fontSize: moderateScale(11),*!/}
                                                          {/!*color: Colors.gray,*!/}

                                                          {/!*!// marginTop: moderateScale(10)*!/}
                                                          {/!*}}*!/}
                                                          {/!*text={item.lastWork && item.lastWork.length > 0 ? item.lastWork.length : 0}*!/}
                                                          {/!*!//   text={"98/03/21"}*!/}
                                                          {/!*!/>*!/}
                                                      </View>
                                                  }

                                              </View>


                                          </View>
                                          {/!*         </CardItem>
                                              </Card>*!/}
                                      </View>
                                  );*/
                        }

                        }
                        // scrollEnabled={true}
                        // scrollEnabled={true}

                        // getItemLayout={(data, index) => {console.log(data, index)}
                        //     //({length: ITEM_HEIGHT, offset: ITEM_HEIGHT * index, index})
                        // }
                        //  onViewableItemsChanged={this._onViewableItemsChanged}
                        //viewabilityConfig={this._viewabilityConfig}
                        // progressViewOffset={(a) => {
                        // }}
                        onScroll={(event) => {
                            const slideSize = event.nativeEvent.layoutMeasurement.height;
                            const index = event.nativeEvent.contentOffset.y / slideSize;
                            const roundIndex = Math.round(index);
                            if (roundIndex === 0) {
                                this._toggle(true)
                            }

                            if (roundIndex === 1) {
                                this._toggle(false)
                            }
                        }
                        }
                        onScrollToIndexFailed={(error) => {
                            //  alert("dfgf")
                            this.list.scrollToOffset({
                                offset: error.averageItemLength * error.index,
                                animated: true
                            });
                            setTimeout(() => {
                                if (lastWork.length !== 0 && this.list !== null) {
                                    this.list.scrollToIndex({
                                        index: error.index,
                                        animated: true
                                    });
                                }
                            }, 100);
                        }}
                        inverted
                    />

            }
            {
                (item_parent?.type == 7 || type == "requestMahalehMa") && !data.flagExpert ?
                    <View style={{width: "100%"}}>
                        <View
                            style={{
                                width: "100%",

                                marginVertical: moderateScale(10)
                                // alignItems: "center"
                            }}>

                            <View
                                style={{
                                    borderRadius: moderateScale(8),
                                    borderColor: Colors.blackLight,
                                    borderWidth: moderateScale(1),
                                    width: "98%",
                                    minHeight: moderateScale(80),
                                    alignSelf: "center",
                                    backgroundColor: Colors.white,
                                    padding: moderateScale(10),
                                    marginTop: moderateScale(10),
                                    marginBottom: moderateScale(2),
                                    paddingTop: moderateScale(22)
                                    //  height: moderateScale(300)
                                }}>
                                {
                                    data.listMessageExpert && data.listMessageExpert.length > 0 ?
                                        <View style={{width: "100%"}}>
                                            <View
                                                style={{
                                                    width: "100%",
                                                    flexDirection: "row",
                                                    alignItems: "center"
                                                }}>
                                                <HMTextView type={"bold"}
                                                            noFont={!I18nManager.isRTL}
                                                            style={{
                                                                fontSize: moderateScale(13),
                                                                color: Colors.colorDarkText,
                                                                textAlign: "center"
                                                            }}
                                                            text={data.listMessageExpert[0].date}
                                                    //   text={"98/03/21"}
                                                />
                                                <View style={{flex: 1, marginHorizontal: moderateScale(10)}}>
                                                    <HMTextView type={"bold"}
                                                                noFont={!I18nManager.isRTL}
                                                                style={{
                                                                    fontSize: moderateScale(13),
                                                                    color: Colors.colorDarkText,
                                                                }}
                                                                text={data.listMessageExpert[0].name}
                                                        //   text={"98/03/21"}
                                                    />
                                                    <HMTextView type={"bold"}
                                                                noFont={!I18nManager.isRTL}
                                                                style={{
                                                                    fontSize: moderateScale(13),
                                                                    color: Colors.colorDarkText,
                                                                }}
                                                                text={data.listMessageExpert[0].description}
                                                        //   text={"98/03/21"}
                                                    />
                                                </View>
                                                {/*   <HMIcon
                                                    type={"MaterialCommunityIcons"}
                                                    name={"lead-pencil"}
                                                    onPress={() => {
                                                        NavigationService.navigateParams("ExpertRegistrationMahaleMaScreen", {
                                                            itemExtra: item,
                                                            //itemExtra: JSON.stringify(item),
                                                            type: "add",
                                                            edit: data.listMessageExpert?.[0]
                                                            // indexExtra: index
                                                        })
                                                    }}
                                                    style={{color: "#de9f1f", fontSize: moderateScale(28)}}
                                                />
                                                <HMIcon name={"ios-close"}
                                                        onPress={() => {
                                                            //  let res_item = props.route.params.item;


                                                            let obj = this.state.stateItemExtra;
                                                            obj["listMessageExpert"] = [];
                                                            this.setState({
                                                                    stateItemExtra: obj,
                                                                    alaki: !this.state.alaki
                                                                },
                                                                () => {
                                                                    //  this.goToIndex(lastWork && lastWork.length > 0 ? lastWork.length - 1 : 0)

                                                                });
                                                        }}
                                                        style={{color: Colors.red, fontSize: moderateScale(32)}}
                                                />*/}
                                            </View>
                                            {this.renderFiles(data.listMessageExpert[0].files, null, true)}
                                        </View>
                                        :
                                        null
                                }
                                {/*  <HMFilesTest
                                    onlyShow
                                    pathVideo={"https://my.arak.ir/proxy/arak/137/proxyPortal.php/storage/2021/May/week2/564508_1620808463020.mp4"}
                                    pathAudio={"https://my.arak.ir/proxy/arak/137/proxyPortal.php/storage/2020/December/week3/484887_1608533505888.aac"}
                                    pathImages={[ "https://my.arak.ir/proxy/arak/137/proxyPortal.php/storage/2021/May/week2/564514_1620808463020.jpg", "https://my.arak.ir/proxy/arak/137/proxyPortal.php/storage/2020/December/week3/484897_1608533505888.jpg"]}
                                    stateParent={this.state}
                                    _setStateData={this._setStateData}
                                    // _setStateDataParent={container.props._setStateData}
                                    SizeBox={3}
                                    styleRoot2={{
                                        flexDirection: 'row',
                                        flexWrap: 'wrap',
                                        width: "100%",

                                        // flexGrow: 1,
                                        //  backgroundColor: "#ee04d0",
                                        alignItems: "flex-start"

                                    }}
                                    //clearState={this.clearState}

                                />*/}
                            </View>


                            <View
                                style={{
                                    flexDirection: "row",
                                    position: 'absolute',
                                    top: '0',
                                    left: moderateScale(30),
                                    backgroundColor: Colors.white,
                                    paddingHorizontal: moderateScale(6),
                                    alignItems: "center",
                                    borderRadius: moderateScale(8)
                                }}>
                                {
                                    data.listMessageExpert && data.listMessageExpert.length > 0 ?

                                        null
                                        :
                                        <HMIcon
                                            styleRoot={{
                                                position: 'absolute',
                                                left: '0',
                                            }}
                                            name={"ios-add-circle"}
                                            onPress={() => {
                                                if (data.listMessageExpert && data.listMessageExpert.length > 0) {

                                                }
                                                else NavigationService.navigateParams("ExpertRegistrationMahaleMaScreen", {
                                                    itemExtra: item,
                                                    //itemExtra: JSON.stringify(item),
                                                    type: "add",
                                                    // edit:data.listMessageExpert
                                                    // indexExtra: index
                                                })
                                            }}
                                            style={{color: Colors.blue, fontSize: moderateScale(28)}}
                                        />


                                }
                                {
                                    item.imageExpert || true ?
                                        <TouchableOpacity
                                            style={{
                                                width: moderateScale(30),
                                                height: moderateScale(30),
                                                marginHorizontal: moderateScale(10)
                                            }}
                                            onPress={() => {
                                                if (data.listMessageExpert && data.listMessageExpert.length > 0) {

                                                }
                                                else
                                                    NavigationService.navigateParams("ExpertRegistrationMahaleMaScreen", {
                                                        //itemExtra: JSON.stringify(item),
                                                        itemExtra: item,
                                                        type: "add",
                                                        // indexExtra: index
                                                    })
                                            }}
                                        >
                                            <HMImageView
                                                resizeMode={'contain'}
                                                uriComplete={item.imageExpert ? item.imageExpert : "http://portal.arak.ir/layouts/v7/lib/todc/img/worker.png?v=1"}
                                                _backgroundColorLoading={Colors.transparent}
                                                styleImage={{
                                                    //  resizeMode: 'cover',
                                                    width: "100%",
                                                    height: "100%",
                                                    // backgroundColor: "#ee7e0c",
                                                    //  borderTopRightRadius:moderateScale(8),
                                                    //borderTopEndRadius: moderateScale(12),
                                                    // borderTopStartRadius: moderateScale(8),
                                                }}
                                                //  onLoad={this._onLoad}
                                                //   onError={status !== 3 ? this._onError : undefined} // prevent infinite-loop bug
                                            />
                                        </TouchableOpacity>
                                        :
                                        null
                                }


                                {/*  <HMFlatList

                                            // ItemSeparatorComponent={
                                            //     <View style={{
                                            //         width: '100%',
                                            //         height: moderateScale(1),
                                            //         backgroundColor: '#4f4f4f'
                                            //     }}/>
                                            // }
                                            // data={lastWork === null || !lastWork ? [] : lastWork}
                                            // extraData={lastWork}
                                            ref={(ref) => {
                                                //this.list = ref.flatListRef.current;
                                                this.listExpertRef = ref && ref.flatListRef?.current;
                                            }}
                                            extraData={this.state}
                                            keyExtractor={(item, index) => index.toString() + (lastWork?.length)}

                                            data={listExpert === null || !listExpert ? [] : listExpert}
                                            // style={{transform: [{scaleY: -1}]}}
                                            // initialScrollIndex={1}
                                            renderItem={({item: itemLastWork, index: indexLastWork}) => {



                                                return (
                                                    <View key={indexLastWork}
                                                          style={{
                                                              width: "100%",
                                                              //transform: [{scaleY: -1}]
                                                          }}
                                                    >


                                                    </View>
                                                );

                                            }

                                            }

                                            onScroll={(event) => {
                                                const slideSize = event.nativeEvent.layoutMeasurement.height;
                                                const index = event.nativeEvent.contentOffset.y / slideSize;
                                                const roundIndex = Math.round(index);
                                                if (roundIndex === 0) {
                                                    this._toggle(true)
                                                }

                                                if (roundIndex === 1) {
                                                    this._toggle(false)
                                                }
                                            }
                                            }
                                            onScrollToIndexFailed={(error) => {
                                                //  alert("dfgf")
                                                this.listExpertRef.scrollToOffset({
                                                    offset: error.averageItemLength * error.index,
                                                    animated: true
                                                });
                                                setTimeout(() => {
                                                    if (lastWork.length !== 0 && this.listExpertRef !== null) {
                                                        this.listExpertRef.scrollToIndex({
                                                            index: error.index,
                                                            animated: true
                                                        });
                                                    }
                                                }, 100);
                                            }}
                                            inverted
                                        />*/}
                                <HMTextView type={"bold"}
                                            noFont={!I18nManager.isRTL}
                                            style={{
                                                fontSize: moderateScale(13),
                                                color: Colors.colorDarkText,
                                            }}
                                            text={"نیاز به کارشناسی دارد؟ "}
                                    //   text={"98/03/21"}
                                />

                            </View>

                        </View>


                        <View
                            style={{
                                width: "96%",
                                flexDirection: "row",
                                flexWrap: 'wrap',
                                alignSelf: "center",
                                alignItems: "center"
                            }}>
                            <HMTextView type={"bold"}
                                        noFont={!I18nManager.isRTL}
                                        style={{
                                            fontSize: moderateScale(13),
                                            color: Colors.blackLight,
                                        }}
                                        text={"در برنامه های جاری منطقه قابل انجام است؟"}
                                //   text={"98/03/21"}
                            />
                            <View
                                style={{width: moderateScale(120)}}

                            >
                                <HMListCheckBox
                                    data={{
                                        list: [
                                            {id: 2, name: "خیر"},
                                            {id: 1, name: "بله"},


                                        ],
                                        indexSelect: this.state['indexSelectCheckBoxProgramNow'],
                                        name: 'ProgramNow',

                                    }}
                                    onPress={
                                        this.onPressSelectCheckBox
                                    }
                                />
                            </View>
                            {
                                this.state.indexSelectCheckBoxProgramNow == 1 ?
                                    <View style={{
                                        width: "100%",
                                        //   justifyContent: "space-between",
                                        //   flexDirection: "row", flexWrap: "wrap"
                                    }}>
                                        <View
                                            style={{
                                                //flex: 1,
                                                flexDirection: "row",
                                                alignItems: "center",
                                                marginEnd: "",
                                                //       backgroundColor: "#ee7a00"
                                            }}>
                                            <HMTextView type={"bold"}
                                                        noFont={!I18nManager.isRTL}
                                                        style={{
                                                            fontSize: moderateScale(13),
                                                            color: Colors.colorDark,
                                                        }}
                                                        text={"چند روز کاری برای انجام کار پیش بینی میگردد؟"}
                                                //   text={"98/03/21"}
                                            />
                                            <HMTextInput
                                                _ref={(ref) => this.TextInputProgramNowRef = ref}
                                                // style={{height: moderateScale(40),
                                                //     borderColor: 'gray',
                                                //     borderWidth: moderateScale(1),
                                                //     textAlign: I18nManager.isRTL && Platform.OS!=='web'? 'right' : 'left',
                                                //
                                                // }}
                                                //  title={ "نام کاربری"}
                                                placeholder={"وارد نمایید"}
                                                // title={'constant.phoneNumber'}
                                                // placeholder={'constant.PH_phoneNumber'}
                                                // lang
                                                styleTitle={{color: Colors.blackLight}}
                                                onChangeText={text => this.onChangeText("TextInputProgramNow", text)}
                                                onSubmitEditing={() => {
                                                    //  this.checkMobile(this.state.mobile)
                                                }}
                                                // onPressClear={() => this.onChangeText("value", null)}
                                                onPressClear={() => {
                                                    this.onChangeText("TextInputProgramNow", null)
                                                    this.TextInputProgramNowRef.clear()
                                                }}
                                                value={this.state.TextInputProgramNow}
                                                keyboardType="numeric"
                                                styleRoot={{
                                                    borderRadius: moderateScale(8),
                                                    borderColor: Colors.blackLight,
                                                    borderWidth: moderateScale(1),
                                                    marginHorizontal: moderateScale(10)
                                                }}
                                            />
                                            <HMTextView type={"bold"}
                                                        noFont={!I18nManager.isRTL}
                                                        style={{
                                                            fontSize: moderateScale(13),
                                                            color: Colors.colorDark,
                                                        }}
                                                        text={"روزکاری"}
                                                //   text={"98/03/21"}
                                            />
                                        </View>
                                        <View
                                            style={{
                                                //flex: 1,
                                                flexDirection: "row",
                                                alignItems: "center",
                                                //   marginStart: moderateScale(50)
                                                //       backgroundColor: "#ee7a00"
                                            }}>
                                            <HMTextView type={"bold"}
                                                        noFont={!I18nManager.isRTL}
                                                        style={{
                                                            fontSize: moderateScale(13),
                                                            color: Colors.colorDark,
                                                        }}
                                                        text={"برآورد بودجه"}
                                                //   text={"98/03/21"}
                                            />
                                            <HMTextInput
                                                _ref={(ref) => this.TextInputCostProgramNowRef = ref}
                                                // style={{height: moderateScale(40),
                                                //     borderColor: 'gray',
                                                //     borderWidth: moderateScale(1),
                                                //     textAlign: I18nManager.isRTL && Platform.OS!=='web'? 'right' : 'left',
                                                //
                                                // }}
                                                //  title={ "نام کاربری"}
                                                placeholder={"وارد نمایید"}
                                                // title={'constant.phoneNumber'}
                                                // placeholder={'constant.PH_phoneNumber'}
                                                // lang
                                                styleTitle={{color: Colors.blackLight}}
                                                onChangeText={text => this.onChangeText("TextInputCostProgramNow", text)}
                                                onSubmitEditing={() => {
                                                    //  this.checkMobile(this.state.mobile)
                                                }}
                                                // onPressClear={() => this.onChangeText("value", null)}
                                                onPressClear={() => {
                                                    this.onChangeText("TextInputCostProgramNow", null)
                                                    this.TextInputCostProgramNowRef.clear()
                                                }}
                                                value={this.state.TextInputCostProgramNow}
                                                keyboardType="numeric"
                                                styleRoot={{
                                                    borderRadius: moderateScale(8),
                                                    borderColor: Colors.blackLight,
                                                    borderWidth: moderateScale(1),
                                                    marginHorizontal: moderateScale(10)
                                                }}
                                            />
                                            <HMTextView type={"bold"}
                                                        noFont={!I18nManager.isRTL}
                                                        style={{
                                                            fontSize: moderateScale(13),
                                                            color: Colors.colorDark,
                                                        }}
                                                        text={"میلیون تومان"}
                                                //   text={"98/03/21"}
                                            />
                                        </View>
                                    </View>
                                    :
                                    null

                            }
                        </View>

                        <View
                            style={{
                                width: "96%",
                                flexDirection: "row",
                                flexWrap: 'wrap',
                                alignSelf: "center",
                                alignItems: "center",
                                marginTop: moderateScale(6),
                                marginBottom: moderateScale(12),
                            }}>
                            <HMTextView type={"bold"}
                                        noFont={!I18nManager.isRTL}
                                        style={{
                                            fontSize: moderateScale(13),
                                            color: Colors.blackLight,
                                        }}
                                        text={"آیا در برنامه های آتی منطقه می تواند قرار گیرد؟"}
                                //   text={"98/03/21"}
                            />
                            <View
                                style={{width: moderateScale(120)}}

                            >
                                <HMListCheckBox
                                    data={{
                                        list: [
                                            {id: 2, name: "خیر"},

                                            {id: 1, name: "بله"},

                                        ],
                                        indexSelect: this.state['indexSelectCheckBoxProgramFuture'],
                                        name: 'ProgramFuture',

                                    }}
                                    onPress={
                                        this.onPressSelectCheckBox
                                    }

                                />
                            </View>

                            {
                                this.state.indexSelectCheckBoxProgramFuture == 1 ?
                                    <View style={{
                                        width: '100%'
                                    }}>
                                        <View
                                            style={{
                                                //flex: 1,
                                                flexDirection: "row",
                                                alignItems: "center",
                                                //       backgroundColor: "#ee7a00"
                                            }}>
                                            <HMTextView type={"bold"}
                                                        noFont={!I18nManager.isRTL}
                                                        style={{
                                                            fontSize: moderateScale(13),
                                                            color: Colors.colorDark,
                                                        }}
                                                        text={"چند روز کاری برای انجام کار آتی پیش بینی میگردد؟"}
                                                //   text={"98/03/21"}
                                            />
                                            <HMTextInput
                                                _ref={(ref) => this.TextInputProgramFutureRef = ref}
                                                // style={{height: moderateScale(40),
                                                //     borderColor: 'gray',
                                                //     borderWidth: moderateScale(1),
                                                //     textAlign: I18nManager.isRTL && Platform.OS!=='web'? 'right' : 'left',
                                                //
                                                // }}
                                                //  title={ "نام کاربری"}
                                                placeholder={"وارد نمایید "}
                                                // title={'constant.phoneNumber'}
                                                // placeholder={'constant.PH_phoneNumber'}
                                                // lang
                                                styleTitle={{color: Colors.blackLight}}
                                                onChangeText={text => this.onChangeText("TextInputProgramFuture", text)}
                                                onSubmitEditing={() => {
                                                    //  this.checkMobile(this.state.mobile)
                                                }}
                                                // onPressClear={() => this.onChangeText("value", null)}
                                                onPressClear={() => {
                                                    this.onChangeText("TextInputProgramFuture", null)
                                                    this.TextInputProgramFutureRef.clear()
                                                }}
                                                value={this.state.TextInputProgramFuture}
                                                keyboardType="numeric"
                                                styleRoot={{
                                                    borderRadius: moderateScale(8),
                                                    borderColor: Colors.blackLight,
                                                    borderWidth: moderateScale(1),
                                                    marginHorizontal: moderateScale(10)
                                                }}
                                            />
                                            <HMTextView type={"bold"}
                                                        noFont={!I18nManager.isRTL}
                                                        style={{
                                                            fontSize: moderateScale(13),
                                                            color: Colors.colorDark,
                                                        }}
                                                        text={"روزکاری آینده انجام خواهد شد"}
                                                //   text={"98/03/21"}
                                            />
                                        </View>
                                        <View
                                            style={{
                                                //flex: 1,
                                                flexDirection: "row",
                                                alignItems: "center",
                                                //       backgroundColor: "#ee7a00"
                                            }}>
                                            <HMTextView type={"bold"}
                                                        noFont={!I18nManager.isRTL}
                                                        style={{
                                                            fontSize: moderateScale(13),
                                                            color: Colors.colorDark,
                                                        }}
                                                        text={"برآورد بودجه آتی"}
                                                //   text={"98/03/21"}
                                            />
                                            <HMTextInput
                                                _ref={(ref) => this.TextInputCostProgramFutureRef = ref}
                                                // style={{height: moderateScale(40),
                                                //     borderColor: 'gray',
                                                //     borderWidth: moderateScale(1),
                                                //     textAlign: I18nManager.isRTL && Platform.OS!=='web'? 'right' : 'left',
                                                //
                                                // }}
                                                //  title={ "نام کاربری"}
                                                placeholder={"وارد نمایید "}
                                                // title={'constant.phoneNumber'}
                                                // placeholder={'constant.PH_phoneNumber'}
                                                // lang
                                                styleTitle={{color: Colors.blackLight}}
                                                onChangeText={text => this.onChangeText("TextInputCostProgramFuture", text)}
                                                onSubmitEditing={() => {
                                                    //  this.checkMobile(this.state.mobile)
                                                }}
                                                // onPressClear={() => this.onChangeText("value", null)}
                                                onPressClear={() => {
                                                    this.onChangeText("TextInputCostProgramFuture", null)
                                                    this.TextInputCostProgramFutureRef.clear()
                                                }}
                                                value={this.state.TextInputCostProgramFuture}
                                                keyboardType="numeric"
                                                styleRoot={{
                                                    borderRadius: moderateScale(8),
                                                    borderColor: Colors.blackLight,
                                                    borderWidth: moderateScale(1),
                                                    marginHorizontal: moderateScale(10)
                                                }}
                                            />
                                            <HMTextView type={"bold"}
                                                        noFont={!I18nManager.isRTL}
                                                        style={{
                                                            fontSize: moderateScale(13),
                                                            color: Colors.colorDark,
                                                        }}
                                                        text={"میلیون تومان"}
                                                //   text={"98/03/21"}
                                            />
                                        </View>
                                    </View>
                                    :
                                    null

                            }
                        </View>

                        <HMTextInput
                           // _ref={(ref) => this.TextInputDescriptionExpertRef = ref}
                            onRef={(ref) => { this.TextInputDescriptionExpertRef = ref?.textInput }}
                            // style={{height: moderateScale(40),
                            //     borderColor: 'gray',
                            //     borderWidth: moderateScale(1),
                            //     textAlign: I18nManager.isRTL && Platform.OS!=='web'? 'right' : 'left',
                            //
                            // }}
                            //  title={'constant.descCode'}
                            title={this.state.TextInputDescriptionExpert && this.state.TextInputDescriptionExpert.length > 0 ? "توضیحات" : null}
                            placeholder={'توضیحات'}

                            // noLangTitle
                            //  placeholder={i18n.t('constant.password')}

                            //lang
                            styleTitle={{color: Colors.blackLight}}
                            onChangeText={text => this.onChangeText("TextInputDescriptionExpert", text)}
                            onSubmitEditing={() => {
                                this.checkMobile(this.state.TextInputDescriptionExpert)
                            }}
                            // onPressClear={() => this.onChangeText("code", null)}
                            onPressClear={() => {
                                this.onChangeText("code", null)
                                this.TextInputDescriptionExpertRef.clear()
                            }}
                            value={this.state.TextInputDescriptionExpert}
                            // keyboardType={"numeric"}
                            style={{
                                borderRadius: moderateScale(8),
                                borderColor: Colors.blackLight,
                                borderWidth: moderateScale(1),
                            }}
                            styleRoot={{
                                width: "96%",
                                alignSelf: "center"
                            }}
                            //secureTextEntry={true}
                        />

                        <ScrollView
                            style={{
                                //   backgroundColor:"#dd2dee"
                            }}>
                            <View
                                style={{
                                    //position:'absolute',
                                    flexDirection: "row",
                                    flexWrap: 'wrap',
                                    flex: 1,

                                    flexGrow: 1,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginTop: moderateScale(12)
                                    //  backgroundColor: _main ? "#eee" : Colors.transparent,
                                    //  backgroundColor: "#876a79",
                                }}>
                                {
                                    ListStateChange && ListStateChange.length > 0 ?
                                        ListStateChange.map((item, key) => {
                                                return <TouchableOpacity
                                                    onPress={() => {

                                                        this.setDataServer(item)

                                                    }}
                                                    style={{
                                                        flex: (1 / ListStateChange.length) - .02,
                                                        marginHorizontal: moderateScale(4),
                                                        height: moderateScale(42),
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        backgroundColor: item.color,
                                                        borderRadius: moderateScale(6)

                                                    }}>

                                                    <HMTextView
                                                        //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                        text={item.name} type={"bold"}
                                                        style={{
                                                            fontSize: moderateScale(13),
                                                            marginVertical: moderateScale(6),
                                                            marginHorizontal: moderateScale(4),
                                                            color: Colors.white
                                                        }}/>
                                                </TouchableOpacity>
                                            }
                                        )
                                        :
                                        null
                                }
                            </View>
                        </ScrollView>
                        {/*       <View
                            style={{
                                width: '100%',
                                height: moderateScale(42),
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: moderateScale(10),
                                marginBottom: moderateScale(3),
                            }}
                        >
                            <TouchableOpacity
                                onPress={() => {

                                    this.setDataServer(1)

                                }}
                                style={{
                                    flex: .32,
                                    height: moderateScale(42),
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: Colors.colorPrimary,
                                    borderRadius: moderateScale(6)

                                }}>

                                <HMTextView
                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                    text={"ارجاع برای انجام کار"} type={"bold"}
                                    style={{
                                        fontSize: moderateScale(13),
                                        marginVertical: moderateScale(6),
                                        marginHorizontal: moderateScale(4),
                                        color: Colors.white
                                    }}/>
                            </TouchableOpacity>

                            <View style={{width: moderateScale(8)}}/>
                            <TouchableOpacity

                                onPress={() => {
                                    this.setDataServer(2)

                                }}
                                style={{
                                    flex: .32,
                                    height: moderateScale(42),
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: Colors.yellow,
                                    borderRadius: moderateScale(6)
                                }}>
                                <HMTextView
                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                    text={"در انتظار کارشناس"} type={"bold"}
                                    style={{
                                        fontSize: moderateScale(13),
                                        marginVertical: moderateScale(6),
                                        marginHorizontal: moderateScale(4),
                                        color: Colors.blackLight
                                    }}/>
                            </TouchableOpacity>
                            <View style={{width: moderateScale(8)}}/>
                            <TouchableOpacity

                                onPress={() => {
                                    this.setDataServer(3)
                                }}
                                style={{
                                    flex: .32,
                                    height: moderateScale(42),
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: Colors.red,
                                    borderRadius: moderateScale(6)
                                }}>
                                <HMTextView
                                    //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                    text={"قابل انجام نمی باشد"} type={"bold"}
                                    style={{
                                        fontSize: moderateScale(13),
                                        marginVertical: moderateScale(6),
                                        marginHorizontal: moderateScale(4),
                                        color: Colors.white
                                    }}/>
                            </TouchableOpacity>
                        </View>*/}
                    </View>
                    :
                    null

            }
        </View>
    }

    onPressSelectCheckBox(item, name, check) {
        container.setState({
                //   ['indexSelectCheckBox' + name]: check ? null : (item.id ? item.id : item.value)
                ['indexSelectCheckBox' + name]: (item.id ? item.id : item.value)
            },
            () => {
            })
    }

    onChangeText(name, text) {
        this.setState({[name]: text}, () => {
        });
    }

    goToIndex(index) {
        // let {lastWork, messageid} = container.state.stateItemExtra
        if (container.list && index >= 0)
            setTimeout(function () {


                try {
                    container.scrollView.scrollToEnd({animated: true})
                    // container.list.scrollToIndex({animated: true, index: index});

                } catch (e) {
                    console.error(e)
                }

            }, 100)

    }

    _toggle(isActive) {
        //  const {animationDuration, easing, useNativeDriver} = this.props;
        //this.isActive = isActive;
        Animated.timing(this.state.focusedAnim, {
            toValue: isActive ? 1 : 0,
            // toValue: 1,
            duration: 300,
            //  easing,
            // useNativeDriver,
        }).start();
    }


}
/*const styles = StyleSheet.create({
    /!* container: {
         marginVertical: 5,
         borderRadius: 4,
         borderStyle: 'solid',
         borderWidth: 2,
         borderColor: Colors.green,
         backgroundColor: Colors.white,
         flex: 0,
         height: 'auto',
         overflow: 'hidden'
     },*!/
    input: {
        height: moderateScale(100),
        backgroundColor: Colors.white,
        fontWeight: '600',
        fontSize: 11,
    },
    contain: {
        flex: 1,
        height: 150,
        width: "100%",
        // height: "100%",
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
    },


    container: {
        paddingHorizontal: BASE_PADDING,
    },
    closeButton: {
        color: 'white',
        borderWidth: 1,
        borderColor: 'white',
        padding: 8,
        borderRadius: 3,
        textAlign: 'center',
        margin: 10,
        alignSelf: 'flex-end',
    },
    customHeaderBox: {
        height: 150,
        backgroundColor: '#6C7A89',
        justifyContent: 'center',
        alignItems: 'center',
    },
    row: {
        flexDirection: 'row',
        marginLeft: -BASE_PADDING,
        marginRight: -BASE_PADDING,
    },
    col: {
        flex: 1,
    },
    square: {
        //  width: WINDOW_WIDTH ,
        // height: WINDOW_WIDTH ,
        justifyContent: 'center',
        alignSelf: 'center',
    },
    squareFirst: {
        backgroundColor: '#C0392B',
    },
    squareSecond: {
        backgroundColor: '#019875',
    },
    squareText: {
        textAlign: 'center',
        color: 'white',
    },
    carousel: {
        height: WINDOW_WIDTH - BASE_PADDING * 2,
        width: WINDOW_WIDTH - BASE_PADDING * 2,
        backgroundColor: 'white',
    },
    text: {
        marginVertical: BASE_PADDING * 2,
    },
    /!* size: {
         input: moderateScale(100),
         icon: 20
     }*!/
});*/

